<template>
  <div class="container mt-3 pb-6">
    <inertia-head>
      <title>{{ event.title_en }} - {{ category.title_th }}</title>
    </inertia-head>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><inertia-link :href="route('home',)" class="">Home</inertia-link></li>
        <li class="breadcrumb-item"><inertia-link :href="route('plan',)" class="">{{ $trans('raceplan.home.FIND_YOUR_RACE') }}</inertia-link></li>
        <li class="breadcrumb-item"><inertia-link :href="route('events.show', event.slug)" class="">{{ event.slug }}</inertia-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ category['title_'+this.$locale()] }}</li>
      </ol>
    </nav>
    <div class="feature_header text-center d-print-none">
      <h3 class="feature_title" style="margin:0;width:100%" id="feature_title">
        <inertia-link :href="route('events.show', [event.slug])">
          <b>{{ event['title_'+this.$locale()] }}</b>
        </inertia-link>
      </h3>
    </div>
    <table class="template">
      <tr class="d-print-none">
        <td rowspan="2" id="event-header-box">
          <div id="event-header">{{ category['title_'+this.$locale()] }}</div>
          <div id="event-sub-header">&nbsp;</div>
          <div id="event-date">{{ category.start_date }}</div>
        </td>
        <td class="link-box" colspan="2" :class="{'bg-dark-blue' : countdown_day <= 0}">
          <a v-if="category.is_gpx_public" :class="{'text-white': countdown_day <= 0}" :href="category.gpx_url">
            <font-awesome-icon :icon="['far', 'map']"/>
            {{ $trans('raceplan.event_category.download') }} GPX
          </a>
        </td>
      </tr>
      <tr class="d-print-none">
        <td colspan="2" id="countdown-box" class="bg-dark-blue" v-if="countdown_day > 0">
          <span v-html="$trans('raceplan.event_category.race_countdown_text')"></span><br>
          <span id="countdown">{{ countdown_day }}</span> {{ $trans('raceplan.event_category.days', {args: {count: countdown_day}, pluralize: true}) }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="td-chart">
          <div class="remove-me" id="mapContainer" style="height: 50vh; max-height: 500px; width: 100%;"></div>
          <div class="m-2">
            <input type="range" class="form-range" min="0" :max="predict_times_key.length-1" :step="1" id="time_slider" @input="changeTimeRange" v-model="time_slider">
          </div>
          <div class="chart_area_parent">
            <div id="chart_area" class="chart print-chart" v-show="isShowChart">
              <div class="row g-0">
                <div class="col-7">
                  <img src="/asset/image/logo.svg" style="max-height: 40px;margin-bottom: 10px;">
                  <div>{{ $trans('raceplan.event_category.name') }}: {{ $page.props.auth.loggedIn ? $page.props.auth.user.fullname_en : 'Not Login' }}</div>
                  <div>{{ $trans('raceplan.event_category.target_time') }}: {{ String(total_hour).padStart(2, '0') }}:{{ String(total_minute).padStart(2, '0') }}</div>
                </div>
                <div class="col-5 text-end" style="margin: auto;">
                  <img v-if="event.sponsor_logo" class="chart_area_logo" :src="event.sponsor_logo" style="max-height: 100px;">
                  <img class="chart_area_logo" :src="event.logo" style="max-height: 100px;">
                </div>
              </div>
              <div class="row" style="margin-right: 0px;padding-top: 10px;">
                <div class="col">
                  <div class="text-center" v-html="world_date_slider_label"></div>
                </div>
              </div>
              <div class="row" style="margin-right: 0px">
                <div class="col">
                  <div class="time_label" v-html="world_time_slider_label"></div>
                </div>
                <div class="col">
                  <div class="time_label" v-html="time_slider_label"></div>
                </div>
              </div>
              <apexchart
                ref="chart_elevation"
                type="area"
                :height="chartHeight"
                :options="chart_elevation_options"
                :series="chart_elevation_series"
              ></apexchart>
              <img :src="'/asset/image/'+category.path_type+'.png?v=1.2.0'" style="width: 100%;">
            </div>
          </div>
        </td>
      </tr>
    </table>

    <div>
      <div class="step" :class="{'step-active': currentStep===1,}" @click="setStep(1)">
        <div>
          <div class="circle">1</div>
        </div>
        <div>
          <div class="title">{{ $trans('raceplan.event_category.set_target_time') }}</div>
          <div class="caption">
            {{ $trans('raceplan.event_category.enter_target_time') }}
          </div>
        </div>
      </div>
      <div v-if="true" class="overflow-auto" id="step-1">
        <table class="template table-input d-print-none">
          <tr>
            <th class="">
              {{ $trans('raceplan.event_category.target_time') }}
              <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="Hour : Minute">
                <font-awesome-icon :icon="['fas', 'info-circle']"/>
              </a>
              <span v-if="last_cutoff_minute > 0">
                (COT: {{ last_cutoff_time }})
              </span>
            </th>
            <th>
              {{ $trans('raceplan.event_category.runner_weight') }}
              <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" :title="$trans('raceplan.event_category.kg')">
                <font-awesome-icon :icon="['fas', 'info-circle']"/>
              </a>
            </th>
            <th>
              {{ $trans('raceplan.event_category.backpack_weight') }}
              <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" :title="$trans('raceplan.event_category.kg')">
                <font-awesome-icon :icon="['fas', 'info-circle']"/>
              </a>
            </th>
          </tr>
          <tr>
            <td class="target_time_input">
              <div>
                <input v-model="total_hour" @change="calculatePlan()" class="hour text-center" min="0" type="number"> : <input v-model="total_minute" @change="calculatePlan()" class="minute text-center" min="0" max="59" type="number">
              </div>
              <br>
              <select class="d-none" v-model="formula_type" @change="calculatePlan()">
                <option disabled value="">Please select one</option>
                <option value="km_effort">KM/Effort</option>
                <option value="slowest">Slowest</option>
              </select>
            </td>
            <td>
              <div>
                <input v-model="runnerWeight" @change="changeWeight" min="0" type="number" class="text-center">
              </div>
            </td>
            <td>
              <div>
                <input v-model="backpackWeight" @change="changeWeight" min="0" type="number" class="text-center">
              </div>
            </td>
          </tr>
          <tr style="border-top: 1px solid rgba(245, 245, 245, 1);">
            <th style="display: none;">
              {{ $trans('raceplan.event_category.acc_time') }}
              <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="Hour : Minute">
                <font-awesome-icon :icon="['fas', 'info-circle']"/>
              </a>
            </th>
            <th>
              {{ $trans('raceplan.event_category.start_time') }}
              <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="World time (Hour : Minute)">
                <font-awesome-icon :icon="['fas', 'info-circle']"/>
              </a>
            </th>
            <th>
              {{ $trans('raceplan.event_category.avg_pace') }}
              <a href="#" data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top" title="Time Per 1 KM.<br>Minute : Second">
                <font-awesome-icon :icon="['fas', 'info-circle']"/>
              </a>
            </th>
            <th>{{ $trans('raceplan.event_category.km/incline') }}</th>
          </tr>
          <tr>
            <td style="display: none;">
              {{ chart_accu_time }}
            </td>
            <td>
              <div>
                <input v-model="runner_start_hour" @change="calculatePlan()" class="hour text-center" min="0" type="number"> : <input v-model="runner_start_minute" @change="calculatePlan()" class="minute text-center" min="0" max="59" type="number">
              </div>
            </td>
            <td>
              {{ chart_avg_pace }}
            </td>
            <td>
              <span id="segment-distance">{{ category.distance/1000 }}</span> {{ $trans('raceplan.event_category.km') }}<br>
              ± <span id="segment-incline">{{ category.incline }}</span> {{ $trans('raceplan.event_category.m') }}
            </td>
          </tr>
        </table>
        <div v-if="category.slug">
          <template v-for="game in games">
            <template v-if="$page.props.auth.loggedIn">
              <inertia-link :href="route('events.category.game1', [event.slug, category.slug])+'?join'" v-if="game.type == 'time_tally'">
                <div class="p-5 mb-4 bg-light rounded-3 bg-g bg-1">
                  <div class="container-fluid py-5">
                    <h1 class="display-5 fw-bold text-center text-white text-shadow"><span class="">{{ $trans('raceplan.event_category.join_time_tally') }}</span></h1>
                  </div>
                </div>
              </inertia-link>
            </template>
            <template v-else>
                <button class="p-5 mb-4 bg-light rounded-3 bg-g bg-1" @click="login_alert">
                  <div class="container-fluid py-5">
                    <h1 class="display-5 fw-bold text-center text-white text-shadow"><span class="">{{ $trans('raceplan.event_category.join_time_tally') }}</span></h1>
                  </div>
                </button>
            </template>
          </template>
        </div>
      </div>
      <div class="pagebreak"></div>

      <div class="step" :class="{'step-active': currentStep===2,}" @click="setStep(2)">
        <div>
          <div class="circle">2</div>
        </div>
        <div>
          <div class="title">{{ $trans('raceplan.event_category.cuztomize_race') }}</div>
          <div class="caption">{{ $trans('raceplan.event_category.adjust_time') }}</div>
        </div>
      </div>
      <div id="step-2" v-show="currentStep===2">
        <div class="overflow-auto" >
          <table class="table template table-plan table-striped" id="table-race-plan">
            <thead>
            <tr>
              <th class="section-info" colspan="8">{{ $trans('raceplan.event_category.info') }}</th>
              <th class="section-plan" colspan="7">{{ $trans('raceplan.event_category.section_plan') }}</th>
            </tr>
            <tr>
              <th class="section-info fit-content" v-html="$trans('raceplan.event_category.local_time_br') +' / '+ $trans('raceplan.event_category.temp')"></th>
              <th class="section-info fit-content" v-html="$trans('raceplan.event_category.station')"></th>
              <th class="section-info fit-content" v-html="$trans('raceplan.event_category.dist')"></th>
              <th class="section-info fit-content" v-html="$trans('raceplan.event_category.acc_dist')"></th>
              <th class="section-info fit-content">KmE.</th>
              <th class="section-info fit-content">Cut<br>Off</th>
              <th class="section-info fit-content">Elev.<br>Gain</th>
              <th class="section-info fit-content">Elev.<br>Loss</th>
              <th class="section-plan">Pace</th>
              <th class="section-plan" v-html="$trans('raceplan.event_category.time')"></th>
              <th class="section-plan">Race<br>Time</th>
              <th class="section-plan" v-html="$trans('raceplan.event_category.local_time_br')"></th>
              <th class="section-plan">Margin</th>
              <th class="section-plan fit-content">Manual<br>Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(annotation, index) in annotations" :key="`annotation-${index}`" class="align-bottom" :class="{ 'bg-red' : annotation.margin < 0, 'selected' : chart_selected_result && chart_selected_result.index === index}">
              <template v-if="index == 0">
                <td colspan="1">
                  {{ seconds2time(time2seconds(runner_start_hour+":"+runner_start_minute)).substring(0,5) }}
                  <a :id="'weather_tooltip_'+index" data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top" title="Test">
                    <img v-if="annotation.user_weather_data" style="width: 30px;" :src="'/asset/image/weather_icon/'+annotation.user_weather_data.weather[0].icon+'.svg'" :title="annotation.user_weather_data.weather[0].description">
                  </a>
                </td>
                <td :colspan="chart_selected_result && chart_selected_result.index === index ? 12 : 13">
                  <div class="text-start">
                    {{ annotation.code }} - {{ annotation['title_'+this.$locale()] }}
                  </div>
                </td>
              </template>
              <template v-else>
                <td @click="rowClicked(index)">
                  {{ annotation.world_time }}
                  <a :id="'weather_tooltip_'+index" data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top" title="Test">
                    <img v-if="annotation.user_weather_data" style="width: 30px;" :src="'/asset/image/weather_icon/'+annotation.user_weather_data.weather[0].icon+'.svg'" :title="annotation.user_weather_data.weather[0].description">
                  </a>
                </td>
                <td @click="rowClicked(index)">
                  <div class="text-start div-anno-subset" style="width: 15em;" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                    <strong>{{ sub_anno.code }}</strong> {{ sub_anno.code && sub_anno.code !== '-' ? '-' : '' }} {{ sub_anno['title_'+this.$locale()] }}
                  </div>
                </td>
                <td @click="rowClicked(index)">
                  <div class="text-start div-anno-subset" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                    {{ Math.round(sub_anno.segment_distance) }}
                  </div>
                </td>
                <td @click="rowClicked(index)">
                  <div class="text-start div-anno-subset" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                    {{ Math.round(sub_anno.accu_distance_cal) }}
                  </div>
                </td>
                <td>
                  <div class="text-start div-anno-subset" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                    {{ Math.round(sub_anno.segment_kme) }}
                  </div>
                </td>
                <td @click="rowClicked(index)" class="text-danger">{{ annotation.cutoff_time }}</td>
                <td @click="rowClicked(index)">
                  <div class="text-start div-anno-subset" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                    <div :class="{'height-alert-1': sub_anno.height_increase >= 400 && sub_anno.height_increase < 550, 'height-alert-2': sub_anno.height_increase >= 550 && sub_anno.height_increase < 700, 'height-alert-3': sub_anno.height_increase >= 700 && sub_anno.height_increase < 850, 'height-alert-4': sub_anno.height_increase >= 850, }">
                      {{ sub_anno.height_increase }}
                    </div>
                  </div>
                </td>
                <td @click="rowClicked(index)">
                  <div class="text-start div-anno-subset" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                    <div :class="{'height-alert-1': sub_anno.height_decrease >= 400 && sub_anno.height_decrease < 550, 'height-alert-2': sub_anno.height_decrease >= 550 && sub_anno.height_decrease < 700, 'height-alert-3': sub_anno.height_decrease >= 700 && sub_anno.height_decrease < 850, 'height-alert-4': sub_anno.height_decrease >= 850, }">
                      {{ sub_anno.height_decrease }}
                    </div>
                  </div>
                </td>
                <td :class="{'col-input' : chart_selected_result && chart_selected_result.index === index}" v-if="chart_selected_result && chart_selected_result.index === index">
                  <input v-model="pace_minute" @change="changePaceInput()" class="minute input-time" min="0" type="number"> : <input v-model="pace_second" @change="changePaceInput()" class="second input-time"  min="0" max="59" type="number">
                </td>
                <td v-else @click="rowClicked(index)">
                  {{ annotation.pace }}
                </td>
                <td :class="{'col-input' : chart_selected_result && chart_selected_result.index === index}" v-if="chart_selected_result && chart_selected_result.index === index">
                  <input v-model="time_hour" @keyup.enter="closeKeyboard()" @change="changeTimeInput()" class="hour input-time" min="0" type="number"> : <input v-model="time_minute" v-on:keyup.13="closeKeyboard()" @change="changeTimeInput()" class="minute input-time"  min="0" max="59" type="number">
                </td>
                <td v-else @click="rowClicked(index)">
                  {{ annotation.user_time.slice(0, 5) }}
                </td>
                <td @click="rowClicked(index)">{{ annotation.user_race_time }}</td>
                <td @click="rowClicked(index)">{{ annotation.user_world_time }}</td>
                <td @click="rowClicked(index)">
                  <template v-if="annotation.cutoff_time && annotation.margin >= 0">
                    {{ seconds2time(annotation.margin).slice(0, 5) }}
                  </template>
                  <template v-else-if="annotation.cutoff_time">
                    CUT
                  </template>
                </td>
                <td @click.self="rowClicked(index)">
                  <input type="checkbox" v-model="manual_edit" :value="index" @click="toggleManualEdit(index)">
                </td>
              </template>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="free_images.length > 0" id="free_image_div">
          <div class="row">
            <div class="col-sm-6 col-md-4 text-center p-3" v-for="img in free_images" :key="img.id">
              <template v-if="img.preview_url">
                <a  :href="img.original_link ? img.original_link : img.uploaded_link" target="_blank">
                  <img :src="img.preview_url" class="img-thumbnail p-2">
                </a>
              </template>
              <template v-else-if="img.original_link">
                <a  :href="img.original_link ? img.original_link : img.uploaded_link" target="_blank">
                  <img :src="img.original_link" class="img-thumbnail p-2">
                </a>
              </template>
              <template v-else>
                <a  :href="img.original_link ? img.original_link : img.uploaded_link" target="_blank">
                  <img :src="img.uploaded_link" class="img-thumbnail p-2">
                </a>
              </template>
              <div class="mt-2">
                <template v-if="is_iOS()">
                  <a :href="img.original_link ? img.original_link : img.uploaded_link" class="btn btn-info btn-sm me-2">
                    <font-awesome-icon :icon="['fas', 'download']"/> {{ $trans('raceplan.event_category.download') }}
                  </a>
                </template>
                <template v-else>
                  <button @click="downloadFileFromUrl(img.original_link ? img.original_link : img.uploaded_link)" class="btn btn-info btn-sm me-2">
                    <font-awesome-icon :icon="['fas', 'download']"/> {{ $trans('raceplan.event_category.download') }}
                  </button>
                </template>

                <a :href="'https://www.facebook.com/sharer/sharer.php?u='+fb_share_url+encodeURIComponent(img.original_link)"
                   class="social-network btn btn-primary btn-sm"
                   :style="{ backgroundColor: '#1877f2' }"
                   target="_blank">
                  <font-awesome-icon :icon="['fab', 'facebook']" />
                  <span> Share on Facebook</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagebreak"></div>
      <div v-if="$page.props.auth.loggedIn" class="step" :class="{'step-active': currentStep===3,}" @click="setStep(3)">
        <div>
          <div class="circle">3</div>
        </div>
        <div>
          <div class="title">{{ $trans('raceplan.event_category.plan_your_nutrition') }}</div>
          <div class="caption">{{ $trans('raceplan.event_category.enter_nutrition_plan') }}</div>
          <div class="text-red-600" v-if="!is_user_times_filled">
            <strong>{{ $trans('raceplan.event_category.alert_complete_second_step') }}</strong>
          </div>
        </div>
      </div>
      <div v-show="is_user_times_filled && currentStep===3" class="overflow-auto" id="step-3">
        <table class="table template table-plan table-striped">
          <thead>
          <tr>
            <th class="section-info" colspan="7">{{ $trans('raceplan.event_category.info') }}</th>
            <th class="section-plan" colspan="2">{{ $trans('raceplan.event_category.section_plan') }}</th>
            <th class="section-nutrition-required" colspan="2">{{ $trans('raceplan.event_category.require_nutrient') }}</th>
            <th class="section-nutrition-plan" colspan="4">{{ $trans('raceplan.event_category.nutrition_plan') }}</th>
          </tr>
          <tr>
            <th class="section-info fit-content" v-html="$trans('raceplan.event_category.local_time_br') +' / '+$trans('raceplan.event_category.temp')"></th>
            <th class="section-info fit-content" v-html="$trans('raceplan.event_category.station')"></th>
            <th class="section-info fit-content" v-html="$trans('raceplan.event_category.icon')"></th>
            <th class="section-info fit-content" v-html="$trans('raceplan.event_category.dist')"></th>
            <th class="section-info fit-content" v-html="$trans('raceplan.event_category.acc_dist')"></th>
            <th class="section-info fit-content">KmE.</th>
            <th class="section-info fit-content">Cut<br>Off</th>
            <th class="section-plan fit-content">Race<br>Time</th>
            <th class="section-plan fit-content" v-html="$trans('raceplan.event_category.local_time')"></th>
            <th class="section-nutrition-required fit-content" v-html="$trans('raceplan.event_category.water_ml')"></th>
            <th class="section-nutrition-required fit-content">CAL</th>
            <th class="section-nutrition-plan" v-html="$trans('raceplan.event_category.menu')"></th>
            <th class="section-nutrition-plan fit-content" v-html="$trans('raceplan.event_category.water_ml')"></th>
            <th class="section-nutrition-plan fit-content">CAL</th>
            <th class="section-nutrition-plan fit-content" v-html="$trans('raceplan.event_category.edit')"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(annotation, index) in annotations" :key="`annotation-${index}`" class="align-bottom" :class="{ 'bg-red' : annotation.user_race_time > annotation.cutoff_time, 'selected' : chart_selected_result && chart_selected_result.index === index}">
            <template v-if="index == 0">
              <td>
                {{ annotation.world_time }}
                <a :id="'weather_tooltip_2_'+index" data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top" title="Test">
                  <img v-if="annotation.user_weather_data" style="width: 30px;" :src="'/asset/image/weather_icon/'+annotation.user_weather_data.weather[0].icon+'.svg'" :title="annotation.user_weather_data.weather[0].description">
                </a>
              </td>
              <td colspan="14">
                <div class="text-start">{{ annotation.code }} - {{ annotation['title_'+this.$locale()] }}</div>
              </td>
            </template>
            <template v-else>
              <td @click="rowClicked(index)">
                {{ annotation.world_time }}
                <a :id="'weather_tooltip_2_'+index" data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top" title="Test">
                  <img v-if="annotation.user_weather_data" style="width: 30px;" :src="'/asset/image/weather_icon/'+annotation.user_weather_data.weather[0].icon+'.svg'" :title="annotation.user_weather_data.weather[0].description">
                </a>
              </td>
              <td @click="rowClicked(index)">
                <div class="text-start div-anno-subset" style="width: 15em;" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                  <strong>{{ sub_anno.code  }}</strong> {{ sub_anno.code && sub_anno.code !== '-' ? '-' : '' }} {{ sub_anno['title_'+this.$locale()] }}
                </div>
              </td>
              <td @click="rowClicked(index)" class="text-start">
                <div class="" style="width: 60px;" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                  <template v-for="icon in ['drink', 'snack', 'food']" :key="icon">
                    <img v-if="sub_anno.icons.includes(icon)" :src="'/icon/'+icon+'.png'" style="width: 20px;" :alt="icon">
                  </template>
                </div>
              </td>
              <td @click="rowClicked(index)">
                <div class="text-start div-anno-subset" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                  {{ Math.round(sub_anno.segment_distance) }}
                </div>
              </td>
              <td @click="rowClicked(index)">
                <div class="text-start div-anno-subset" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                  {{ Math.round(sub_anno.accu_distance_cal) }}
                </div>
              </td>
              <td @click="rowClicked(index)">
                <div class="text-start div-anno-subset" v-for="sub_anno in annotation.subset" :key="'sub_anno_'+sub_anno.id">
                  {{ Math.round(sub_anno.segment_kme) }}
                </div>
              </td>
              <td @click="rowClicked(index)" class="text-danger">{{ annotation.cutoff_time }}</td>
              <td @click="rowClicked(index)">{{ annotation.user_race_time }}</td>
              <td @click="rowClicked(index)">{{ annotation.user_world_time }}</td>
              <td @click="rowClicked(index)" class="text-danger">{{ annotation.nutrients.water.require.toFixed(0) }}</td>
              <td @click="rowClicked(index)" class="text-danger">{{ annotation.nutrients.calories.require.toFixed(0) }}</td>
              <td @click="rowClicked(index)">
                <template v-for="food in station_foods">
                  <div v-if="annotations[index].foods[food.id] && annotations[index].foods[food.id].qty > 0"  :key="food['title_'+this.$locale()]" class="text-start">
                    {{ food['title_'+this.$locale()] }} x {{ annotations[index].foods[food.id].qty }}
                  </div>
                </template>
                <template v-for="food in runner_foods">
                  <div v-if="food && food.id && annotations[index].foods[food.id] && annotations[index].foods[food.id].qty > 0"  :key="food['title_'+this.$locale()]" class="text-start">
                    {{ food['title_'+this.$locale()] }} x {{ annotations[index].foods[food.id].qty }}
                  </div>
                </template>
                <template v-for="food in tiein_foods">
                  <div v-if="food && food.id && annotations[index].foods[food.id] && annotations[index].foods[food.id].qty > 0"  :key="food['title_'+this.$locale()]" class="text-start">
                    {{ food['title_'+this.$locale()] }} x {{ annotations[index].foods[food.id].qty }}
                  </div>
                </template>
              </td>
              <td @click="rowClicked(index)" class="text-primary">{{ annotation.nutrients.water.current }}</td>
              <td @click="rowClicked(index)" class="text-primary">{{ annotation.nutrients.calories.current }}</td>
              <td @click.self="rowClicked(index)">
                <button v-if="chart_selected_result && chart_selected_result.index === index" type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                  <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                </button>
              </td>
            </template>
          </tr>
          <tr>
            <td colspan="9"></td>
            <td>{{ total_nutrients.water.toFixed(0) }}</td>
            <td>{{ total_nutrients.calories.toFixed(0) }}</td>
            <td colspan="5"></td>
          </tr>
          </tbody>
        </table>
        * {{ $trans('raceplan.event_category.remark_nutrition_formula') }}<br><br>
        <div v-if="menu_show">
          <ul class="nav nav-tabs" id="menuShowTab" role="tablist">
            <li class="nav-item" role="presentation"  v-for="(group, index) in menu_show" :key="index">
              <button :class="['nav-link', (index === 0 ? 'active' : '')]" :id="index+'-tab'" data-bs-toggle="tab" :data-bs-target="'#menu'+index"
                      type="button" role="tab" :aria-controls="index" aria-selected="true">
                {{ group.type }}
              </button>
            </li>
          </ul>
          <div class="tab-content" id="menuShowTabContent">

            <template  v-for="(group, index) in menu_show">
              <div :class="['tab-pane fade', (index === 0 ? 'show active' : '')]" :id="'menu'+index" role="tabpanel" :aria-labelledby="index+'-tab'">
                <div class="row">
                  <p class="mt-2 text-danger" v-html="$trans('raceplan.event_category.menu_warning')"></p>
                </div>
                <div class="row row-cols-1 row-cols-sma-2 row-cols-md-4 g-3">
                  <template v-for="(menu, idx) in group.data" :key="idx">
                    <div :class="{'col': true, 'cp-food': true, 'not-available': chart_selected_result && menu.cp_list.indexOf(annotations[chart_selected_result.index].checkpoint_id) === -1 }" >


                      <div class="card shadow-sm">
                        <img class="bd-placeholder-img card-img-top" width="100%" height="225"
                             style="height: auto; width: auto;  "
                             role="img" :src="menu.image_url" >


                        <div class="card-body">
                          <p class="card-text text-center">{{ menu.title_en }}</p>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="step" :class="{'step-active': currentStep===4,}" @click="setStep(4)">
        <div>
          <div class="circle">
            {{ this.$page.props.auth.loggedIn ? 4 : 3 }}
          </div>
        </div>
        <div>
          <div class="title">{{ $trans('raceplan.event_category.share_your_plan') }}</div>
        </div>
      </div>
      <div class="text-center m-1" id="step-4" v-show="currentStep===4">
        <button class="btn btn-primary mb-2 me-2" @click="generateGIF" :disabled="download_progress != ''">{{ $trans('raceplan.event_category.download') }} GIF {{ download_progress }}</button>
        <button class="btn btn-primary mb-2 me-2" @click="printClicked('p')">
          <font-awesome-icon :icon="['far', 'file-pdf']"/>
          {{ $trans('raceplan.event_category.download') }} PDF ({{ $trans('raceplan.event_category.portrait') }})
        </button>
        <button class="btn btn-primary mb-2 me-2" @click="printClicked('l')">
          <font-awesome-icon :icon="['far', 'file-pdf']"/>
          {{ $trans('raceplan.event_category.download') }} PDF({{ $trans('raceplan.event_category.landscape') }})
        </button>
        <a v-if="category.is_gpx_public" class="btn btn-primary mb-2 me-2" :href="category.gpx_url">
          <font-awesome-icon :icon="['far', 'map']"/>
          {{ $trans('raceplan.event_category.download') }} GPX
        </a>
      </div>

      <div v-if="category['additional_'+this.$locale()]" class="step" :class="{'step-active': currentStep===6,}" @click="setStep(5)">
        <div>
          <div class="circle">
            <div class="circle">
              {{ this.$page.props.auth.loggedIn ? 5 : 4 }}
            </div>
          </div>
        </div>
        <div>
          <div class="title">{{ $trans('raceplan.event_category.additional') }}</div>
          <div class="caption">{{ $trans('raceplan.event_category.value_training_plan') }}</div>
        </div>
      </div>
      <div id="step-5" v-show="currentStep===5">
        <div v-html="category['additional_'+this.$locale()] ?? $trans('raceplan.event_category.no_data')"></div>
      </div>
    </div>

    <div v-if="chart_selected_result" class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Nutrition - {{ chart_selected_result.annotation.code }} {{ chart_selected_result.annotation['title_'+this.$locale()] }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <table class="table table-nutrition">
              <thead>
              <tr>
                <th colspan="2"></th>
                <template v-for="(nutrient_set, type) in nutrients">
                  <td v-for="nutrient in nutrient_set" :key="nutrient.key">
                    <div :class="{'fw-bold': type === 'mandatory'}">
                      {{ nutrient['title_'+this.$locale()] }} ({{ nutrient['unit_'+this.$locale()] }})
                    </div>
                  </td>
                </template>
              </tr>
              <tr>
                <th colspan="2">Require</th>
                <template v-for="nutrient_set in nutrients">
                  <td class="text-center"  v-for="nutrient in nutrient_set" :key="nutrient.key">
                    {{ +(Math.round(chart_selected_result.annotation.nutrients[nutrient.key].require + "e+2") + "e-2") || 0 }}
                  </td>
                </template>
              </tr>
              <tr>
                <th colspan="2">Current</th>
                <template v-for="nutrient_set in nutrients">
                  <td class="text-center"  v-for="nutrient in nutrient_set" :key="nutrient.key">
                    {{ +(Math.round(chart_selected_result.annotation.nutrients[nutrient.key].current + "e+2") + "e-2") || 0 }}
                  </td>
                </template>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th :colspan="2+Object.keys(chart_selected_result.annotation.nutrients).length">
                  Food at station
                </th>
              </tr>
              <template v-for="food in station_foods" >
                <tr v-if="annotations[chart_selected_result.index].foods[food.id]" :key="food.id">
                  <td>
                    <a href="javascript:{}" @click="changeFoodQty(food.id, -1)">
                      <font-awesome-icon :icon="['fas', 'minus']"/>
                    </a>
                    {{ annotations[chart_selected_result.index].foods[food.id].qty }}
                    <a href="javascript:{}" @click="changeFoodQty(food.id, 1)">
                      <font-awesome-icon :icon="['fas', 'plus']"/>
                    </a>
                  </td>
                  <td>
                    {{ food['title_'+this.$locale()] }}
                  </td>
                  <template v-for="nutrient_set in nutrients">
                    <td class="text-center" v-for="nutrient in nutrient_set" :key="nutrient.key">
                      {{ +(Math.round(annotations[chart_selected_result.index].foods[food.id][nutrient.key] + "e+2") + "e-2") || 0 }}
                      ({{ station_foods[food.id][nutrient.key] }})
                    </td>
                  </template>
                </tr>
              </template>
              </tbody>
              <tbody>
              <tr>
                <th :colspan="2+Object.keys(chart_selected_result.annotation.nutrients).length">
                  Bring your own food
                </th>
              </tr>
              <tr v-for="food_id in Object.keys(tiein_foods).sort()" :key="food_id">
                <td>
                  <a href="javascript:{}" @click="changeFoodQty(food_id, -1)">
                    <font-awesome-icon :icon="['fas', 'minus']"/>
                  </a>
                  {{ annotations[chart_selected_result.index].foods[food_id].qty }}
                  <a href="javascript:{}" @click="changeFoodQty(food_id, 1)">
                    <font-awesome-icon :icon="['fas', 'plus']"/>
                  </a>
                </td>
                <td>
                  {{ tiein_foods[food_id]['title_'+this.$locale()] }}
                </td>
                <template v-for="nutrient_set in nutrients">
                  <td class="text-center" v-for="nutrient in nutrient_set" :key="nutrient.key">
                    {{ +(Math.round(annotations[chart_selected_result.index].foods[food_id][nutrient.key] + "e+2") + "e-2") || 0 }}
                    ({{ tiein_foods[food_id][nutrient.key] }})
                  </td>
                </template>
              </tr>
              <tr v-for="food_id in Object.keys(runner_foods).sort()" :key="food_id">
                <td>
                  <a href="javascript:{}" @click="changeFoodQty(food_id, -1)">
                    <font-awesome-icon :icon="['fas', 'minus']"/>
                  </a>
                  {{ annotations[chart_selected_result.index].foods[food_id].qty }}
                  <a href="javascript:{}" @click="changeFoodQty(food_id, 1)">
                    <font-awesome-icon :icon="['fas', 'plus']"/>
                  </a>
                </td>
                <td>
                  {{ runner_foods[food_id]['title_'+this.$locale()] }}
                  <a href="javascript:{}" class="link-danger" @click="removeMenu(food_id)">
                    <font-awesome-icon :icon="['fas', 'trash']"/>
                  </a>
                </td>
                <template v-for="nutrient_set in nutrients">
                  <td class="text-center" v-for="nutrient in nutrient_set" :key="nutrient.key">
                    {{ +(Math.round(annotations[chart_selected_result.index].foods[food_id][nutrient.key] + "e+2") + "e-2") || 0 }}
                    ({{ runner_foods[food_id][nutrient.key] }})
                  </td>
                </template>
              </tr>
              <tr>
                <td>
                  <button @click="addNewMenu()" class="btn btn-primary btn-sm"><font-awesome-icon :icon="['fas', 'plus']"/></button>
                </td>
                <td>
                  <input class="form-control form-control-sm menu_name" v-model="input_menu_name" placeholder="Enter new menu name">
                  <span v-if="is_validate_menu && !input_menu_name" class="text-danger">Please enter menu name</span>
                </td>
                <template v-for="nutrient_set in nutrients">
                  <td class="text-center" v-for="nutrient in nutrient_set" :key="nutrient.key">
                    <input class="form-control form-control-sm input_menu_nutrients" v-model="input_menu_nutrients[nutrient.key]" type="number" min="0">
                  </td>
                </template>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button @click="autoSuggestNutrient()" class="btn btn-primary"><font-awesome-icon :icon="['fas', 'magic']"/> Auto Suggest</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="briefModal" tabindex="-1" aria-labelledby="briefModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="briefModalLabel">{{ $trans('raceplan.event_category.brief') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="category['brief_'+this.$locale()]" v-html="category['brief_'+this.$locale()] ? category['brief_'+this.$locale()] : 'No Data'"></div>
            <div v-else v-html="event['brief_'+this.$locale()] ? event['brief_'+this.$locale()] : 'No Data'"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="ruleModal" tabindex="-1" aria-labelledby="ruleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ruleModalLabel">{{ $trans('raceplan.event_category.rules') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-html="event['rule_'+this.$locale()] ? event['rule_'+this.$locale()] : 'No Data'"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import axios from 'axios'
import { Tooltip } from "bootstrap/dist/js/bootstrap.bundle.min.js"
import { jsPDF } from "jspdf"
import 'jspdf-autotable'
import THSarabunNew from '@/assets/fonts/THSarabunNew-normal.js'
import THSarabunNew_Bold from '@/assets/fonts/THSarabunNew_Bold-bold.js'
import L from "leaflet";
import "leaflet/dist/leaflet.css"
import "leaflet.fullscreen"
import "leaflet.fullscreen/Control.FullScreen.css";
import GPX from "leaflet-gpx"
import KMZ from "leaflet-kmz"
import gpxParser from "gpxparser"
import VueApexCharts from "vue3-apexcharts"
import GIF from "gif.js.optimized"
import * as htmlToImage from 'html-to-image'
import UAParser from 'ua-parser-js'
import * as Bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js"
import { Boarding } from "boarding.js";
import "boarding.js/styles/main.css";
import "boarding.js/styles/themes/basic.css";
import $ from 'jquery';

import { Buffer } from 'buffer'
//import { ShareNetwork } from "vue3-social-sharing"
//import $ from 'jquery';
export default {
  metaInfo: { title: 'Show' },
  layout: Layout,
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    event: Object,
    station_foods: Object,
    tiein_foods: Object,
    runner_foods_original: Object,
    menu_plan: Object,
    menu_show: Object,
    games: Object,
  },
  data() {
    return {
      annotations: [],
      runner_foods: {},
      category: {},
      total_hour: '',
      total_minute: '',
      runner_start_hour: 0,
      runner_start_minute: 0,
      runner_start: 0,
      original_start_hour: '',
      original_start_minute: '',
      start_hour : '',
      start_minute : '',
      start_diff_seconds: 0,
      pace_minute: '',
      pace_second: '',
      time_hour: '',
      time_minute: '',
      formula_type: 'km_effort',
      chart_accu_time: '',
      chart_avg_pace: '',
      chart_selected_result: null,
      manual_edit: new Set(),
      charts: null,
      chartHeight: 350,
      runnerWeight: 60,
      backpackWeight: 5,
      grade: 6.27,
      input_menu_nutrients: {},
      input_menu_name: '',
      is_validate_menu: false,
      is_user_times_filled: false,
      user_times: {},
      countdown_day: 999,
      nutrients: {
        'mandatory': [
          {key: 'water', title_en: 'Water', unit_en: 'ml.', title_th: 'น้ำ', unit_th: 'มล.'},
          {key: 'calories', title_en: 'Calories', unit_en: 'kcal.', title_th: 'แคลอรี่', unit_th: 'kcal.'},
        ],
        'optional': [
          {key: 'carbohydrate', title_en: 'Carbs', unit_en: 'g.', title_th: 'คาร์โบไฮเดรต', unit_th: 'ก.'},
          {key: 'protein', title_en: 'Protein', unit_en: 'g.', title_th: 'โปรตีน', unit_th: 'ก.'},
          {key: 'sodium', title_en: 'Sodium', unit_en: 'mg.', title_th: 'โซเดียม', unit_th: 'มก.'},
          {key: 'potassium', title_en: 'Potassium', unit_en: 'mg.', title_th: 'โพแทสเซียม', unit_th: 'มก.'},
          {key: 'magnesium', title_en: 'Magnesium', unit_en: 'mg.', title_th: 'แมกนีเซียม', unit_th: 'มก.'},
        ],
      },
      total_nutrients: {water:0, calories:0, sodium:0, potassium:0, carbohydrate:0, protein:0},
      shouldPrint: false,
      isShowChart: false,
      shouldInitCalculatePlan: true,
      currentStep: 1,
      chart_elevation_options: {},
      chart_elevation_options_original: {},
      chart_elevation_series: [],
      world_date_slider_label: '',
      world_time_slider_label: '',
      time_slider_label: '',
      time_slider: 0,
      download_progress: '',
      geo_list: [],
      predict_times_key: [],
      predict_times: {},
      last_cutoff_minute: 0,
      last_cutoff_time: '00:00',
      user_agent: null,
      current_weather_ecc_id: null,
      marker: [],
      layerControl: {},
      runner_markers: {},
      weather_forecast: {},
      search_uid: "",
      free_images: [],
      fb_share_url: "",
      category_start_time: "",
    }
  },
  mounted() {
    this.user_agent = new UAParser(window.navigator.userAgent).getResult(); // you need to pass the user-agent for nodejs
    Array.from(document.querySelectorAll('a[data-bs-toggle="tooltip"]'))
        .forEach(tooltipNode => new Tooltip(tooltipNode))

    L.Marker.prototype._animateZoom = function (opt) {
      if (!this._map) {
        return
      }
      let pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round()
      this._setPos(pos)
    }
    L.Popup.prototype._animateZoom = function (e) {
      if (!this._map) {
        return
      }
      var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
        anchor = this._getAnchor()
      L.DomUtil.setPosition(this._container, pos.add(anchor))
    }
    L.GridLayer.prototype._animateZoom = function (e) {
      if (!this._map) {
        return
      }
      this._setView(e.center, e.zoom, true, e.noUpdate);
    }
    L.GridLayer.prototype._resetView = function (e) {
      if (!this._map) {
        return
      }
      var animating = e && (e.pinch || e.flyTo);
      this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
    }

    this.category = this.event.event_category[0]
    this.runner_foods = this.runner_foods_original

    // Split timestamp into [ Y, M, D, h, m, s ]
    let t = this.category.start_date.split(/[- :]/)
    let today = new Date()
    let category_start_time = new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5])
    this.category_start_time = category_start_time
    this.original_start_hour = parseInt(t[3])
    this.original_start_minute = parseInt(t[4])
    this.runner_start_hour = this.original_start_hour
    this.runner_start_minute = this.original_start_minute
    this.start_hour = parseInt(t[3])
    this.start_minute = parseInt(t[4])
    this.countdown_day = parseInt((category_start_time - today) / (1000 * 60 * 60 * 24), 10)

    let temp_annotations = this.category.event_category_checkpoints
    let annotations = []
    let temp_anno = []
    let new_distance = 0
    let last_accu_dis = 0
    let last_accu_slowest = 0
    let terrain_info_carry = ''
    let terrain_warning_carry = ''
    let kme_carry = 0
    let height_increase_carry = 0
    let height_decrease_carry = 0
    for (let i = 0; i < temp_annotations.length; i++) {
      if(!temp_annotations[i].checkpoint.is_show_raceplan){
        kme_carry += temp_annotations[i].segment_kme
        height_increase_carry += temp_annotations[i].height_increase
        height_decrease_carry += temp_annotations[i].height_decrease
        if(temp_annotations[i]['terrain_detail_'+this.$locale()]){
          terrain_info_carry += temp_annotations[i]['terrain_detail_'+this.$locale()] + "⬇️"
        }
        if(temp_annotations[i]['warning_'+this.$locale()]){
          terrain_warning_carry += temp_annotations[i]['warning_'+this.$locale()] + "⬇️"
        }
        continue
      }
      if(temp_annotations[i].slowest_minute){
        this.formula_type = 'slowest'
      }
      temp_annotations[i]['terrain_detail_'+this.$locale()] = terrain_info_carry + temp_annotations[i]['terrain_detail_'+this.$locale()]
      temp_annotations[i]['warning_'+this.$locale()] = terrain_warning_carry + temp_annotations[i]['warning_'+this.$locale()]
      temp_annotations[i].segment_kme += kme_carry
      temp_annotations[i].height_increase += height_increase_carry
      temp_annotations[i].height_decrease += height_decrease_carry
      terrain_info_carry = ''
      terrain_warning_carry = ''
      kme_carry = 0
      height_increase_carry = 0
      height_decrease_carry = 0
      temp_annotations[i].icon_list.sort()
      temp_annotations[i].segment_distance = temp_annotations[i].accu_distance_cal-last_accu_dis
      last_accu_dis = temp_annotations[i].accu_distance_cal
      temp_annotations[i].segment_slowest_minute = temp_annotations[i].slowest_minute-last_accu_slowest
      last_accu_slowest = temp_annotations[i].slowest_minute
      temp_annotations[i].color = "#775DD0"
      temp_annotations[i].text = temp_annotations[i].code
      temp_annotations[i].x = (temp_annotations[i].accu_distance_cal*1000) + (temp_annotations[i].graph_padding*1000)
      temp_annotations[i].icons = temp_annotations[i].icon_list
      if(!temp_annotations[i].code && !temp_annotations[i].accu_cutoff_time_minute){
        new_distance += temp_annotations[i].segment_distance
        temp_anno.push(JSON.parse(JSON.stringify(temp_annotations[i])))
      }else{
        temp_annotations[i].color = "#ff8f00"
        if(this.category.event_category_checkpoints.length > 0 && i === temp_annotations.length-1){
          temp_annotations[i].color = "#5AB826"
        }
        temp_anno.push(JSON.parse(JSON.stringify(temp_annotations[i])))
        temp_annotations[i].segment_distance = (+(Math.round((new_distance+temp_annotations[i].segment_distance) + "e+2")  + "e-2"))
        temp_annotations[i].subset = JSON.parse(JSON.stringify(temp_anno))
        annotations.push(temp_annotations[i])
        if(i === temp_annotations.length-1){
          this.last_cutoff_minute = temp_annotations[i].accu_cutoff_time_minute ?? 0
          this.last_cutoff_time = this.seconds2time(this.last_cutoff_minute*60).slice(0,5)
        }

        temp_anno = []
      }
    }
    temp_annotations = annotations
    for (let i = 0; i < temp_annotations.length; i++) {
      let world_time = new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5])
      if(temp_annotations[i].accu_cutoff_time_minute){
        temp_annotations[i].cutoff_time = this.seconds2time(temp_annotations[i].accu_cutoff_time_minute*60)
        temp_annotations[i].cutoff_time = temp_annotations[i].cutoff_time.slice(0,5)
      }
      if(i === 0){
        temp_annotations[i].world_time = world_time.toMySQLFormat().slice(11,16)
      }
      if(temp_annotations[i].cutoff_time){
        world_time = world_time.addSeconds(this.time2seconds(temp_annotations[i].cutoff_time))
        temp_annotations[i].world_time = world_time.toMySQLFormat().slice(11,16)
        let days
        if(this.$locale() == 'en'){
          days = ['SUN','MON','TUE','WED','THU','FRI','SAT']
        } else if(this.$locale() == 'th'){
          days = ['อา.','จ.','อ.','พ.','พฤ.','ศ.','ส.']
        }
        temp_annotations[i].world_day = days[world_time.getDay()]
      }

      if(this.$page.props.auth.loggedIn && temp_annotations[i].checkpoint_user && temp_annotations[i].checkpoint_user[0]){
        temp_annotations[i].user_time = this.seconds2time(temp_annotations[i].checkpoint_user[0].segment_time)
        this.shouldInitCalculatePlan = false
        if(temp_annotations[i].checkpoint_user[0].is_manual_edit){
          this.manual_edit.add(i)
        }
      }else{
        temp_annotations[i].user_time = '00:00'
      }

      let nutrients = {}
      for (const type of ['mandatory', 'optional']) {
        for (const nutrient of this.nutrients[type]) {
          nutrients[nutrient.key] = JSON.parse(JSON.stringify(nutrient))
          nutrients[nutrient.key].require = 0
        }
      }
      temp_annotations[i].nutrients = nutrients

      for (const nutrient in temp_annotations[i].nutrients) {
        this.input_menu_nutrients[nutrient] = 0
      }

      temp_annotations[i].foods = {}
      for (const food_id in this.station_foods) {
        if(!this.station_foods[food_id].checkpoint_id || this.station_foods[food_id].checkpoint_id === temp_annotations[i].checkpoint_id){
          temp_annotations[i].foods[food_id] = {qty: 0}
          for (const nutrient in temp_annotations[i].nutrients) {
            temp_annotations[i].foods[food_id][nutrient] = 0
          }
        }
      }
      for (const food_id in this.runner_foods) {
        temp_annotations[i].foods[food_id] = {qty: 0}
        for (const nutrient in temp_annotations[i].nutrients) {
          temp_annotations[i].foods[food_id][nutrient] = 0
        }
      }
      for (const food_id in this.tiein_foods) {
        temp_annotations[i].foods[food_id] = {qty: 0}
        for (const nutrient in temp_annotations[i].nutrients) {
          temp_annotations[i].foods[food_id][nutrient] = 0
        }
      }
      //calculate nutrient
      let sum_nutrient = {}
      for (const food_id in this.menu_plan[temp_annotations[i].checkpoint_id]) {
        temp_annotations[i].foods[food_id] = {qty: this.menu_plan[temp_annotations[i].checkpoint_id][food_id].amount}
        for (const nutrient in temp_annotations[i].nutrients) {
          if(!sum_nutrient[nutrient]){
            sum_nutrient[nutrient] = 0
          }
          if(this.station_foods[food_id]){
            temp_annotations[i].foods[food_id][nutrient] = this.station_foods[food_id][nutrient]*this.menu_plan[temp_annotations[i].checkpoint_id][food_id].amount
          }else if(this.runner_foods[food_id]){
            temp_annotations[i].foods[food_id][nutrient] = this.runner_foods[food_id][nutrient]*this.menu_plan[temp_annotations[i].checkpoint_id][food_id].amount
          } else{
            temp_annotations[i].foods[food_id][nutrient] = this.tiein_foods[food_id][nutrient]*this.menu_plan[temp_annotations[i].checkpoint_id][food_id].amount
          }
          sum_nutrient[nutrient] += temp_annotations[i].foods[food_id][nutrient]
        }
      }
      for (const nutrient in temp_annotations[i].nutrients) {
        temp_annotations[i].nutrients[nutrient].current = sum_nutrient[nutrient]
      }
    }
    if(this.$page.props.auth.loggedIn && this.category.graphs && this.category.graphs[0]){
      this.total_hour = this.category.graphs[0].total_hour
      this.total_minute = this.category.graphs[0].total_minute
      if(!this.category.graphs[0].runner_start_hour && !this.category.graphs[0].runner_start_minute){
        this.runner_start_hour = this.category.start_date.split(' ')[1].split(':')[0]
        this.runner_start_minute = this.category.start_date.split(' ')[1].split(':')[1]
      }else{
        this.runner_start_hour = this.category.graphs[0].runner_start_hour
        this.runner_start_minute = this.category.graphs[0].runner_start_minute
      }
      this.runnerWeight = this.category.graphs[0].runner_weight
      this.backpackWeight = this.category.graphs[0].backpack_weight
      if(this.category.graphs[0].start_hour && this.category.graphs[0].start_minute){
        this.start_hour = this.category.graphs[0].start_hour
        this.start_minute = this.category.graphs[0].start_minute
        this.start_diff_seconds = ((this.original_start_hour - this.start_hour) * 3600) + ((this.original_start_minute - this.start_minute) * 60)
      }
    }else if(this.$page.props.auth.loggedIn){
      this.runnerWeight = this.$page.props.auth.user.weight
      this.backpackWeight = this.$page.props.auth.user.baggage_weight
    }
    this.annotations = temp_annotations
    this.parseGPX()
    this.drawMap()


    const urlParams = new URLSearchParams(window.location.search);
    let search_uid = urlParams.get('search_uid');
    if(search_uid){
      localStorage.setItem(this.event.slug+"_search_uid", search_uid)
    }

    let fbmeta = urlParams.get('fbmeta');
    if(fbmeta && fbmeta.indexOf('search_uid') > -1){
      fbmeta = fbmeta.split(',')
      localStorage.setItem(this.event.slug+"_search_uid", fbmeta[1].replace('search_uid', ''))
    }

    search_uid = localStorage.getItem(this.event.slug+"_search_uid");
    if(search_uid){
      this.search_uid = search_uid
      this.getFreeImages()
    }
  },
  methods: {
    login_alert(){
      alert(this.$trans('auth.login_check'))
    },

    is_iOS() {
      return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
          ].includes(navigator.platform)
          // iPad on iOS 13 detection
          || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    },

    async getFreeImages(){
      let url = "https://media.runningconnect.com/event/"+this.event.slug+"/session_list_api?json=true&search_uid="+this.search_uid
      const response = await axios.get(url, {})
      if(!response.data.status){
        console.log(response.data.message)
        return
      }
      let temp_url = window.location.href.split('?')[0]
      temp_url = temp_url.replace("http://", "")
      temp_url = temp_url.replace("https://", "")
      if(response.data.images && response.data.images.length > 0){
        let title = this.event.title_en.replaceAll(/ /g,"+");
        temp_url += '?fbmeta=v1,search_uid'+this.search_uid+','+encodeURIComponent(title)+','
      }
      temp_url
      this.fb_share_url = temp_url
      this.free_images = response.data.images
    },

    setStep(step){
      this.currentStep = step

      if(this.currentStep === 2){
        if(this.search_uid){
          const boarding = new Boarding({
            scrollIntoViewOptions: {
              behaviour: "smooth",
            },
          });
          boarding.highlight({
            element: "#step-2",
            popover: {
              title: this.$trans('raceplan.event_category.congrats'),
              description: this.$trans('raceplan.event_category.free_photo_instruction3'),
              // prefferedSide can be left, right, top, bottom
              prefferedSide: "bottom",
              // alignment can be start, center, right
              alignment: "center",
            },
          });
        }
      }
    },

    calculatePlan() {

      console.log(this.runner_start_hour)
      console.log(this.original_start_hour)
      console.log(this.runner_start_minute)
      console.log(this.original_start_minute)
      console.log(this.runner_start_hour-this.original_start_hour)
      console.log(this.runner_start_minute-this.original_start_minute)
      if(this.total_hour === "" && this.total_minute === ""){
        return;
      }
      if(this.runner_start_hour === "" || this.runner_start_minute === "" || this.runner_start_hour < this.original_start_hour ||
          (this.runner_start_hour == this.original_start_hour && this.runner_start_minute < this.original_start_minute)
      ){
        console.log('out');
        return;
      }
      if(this.last_cutoff_minute > 0 && (parseInt(this.total_hour)*60 + parseInt(this.total_minute)) > this.last_cutoff_minute){
        this.total_hour = parseInt(this.last_cutoff_time.split(':')[0])
        this.total_minute = parseInt(this.last_cutoff_time.split(':')[1])
      }
      let hour = this.total_hour
      let minute = this.total_minute
      let target_time = (hour*60*60) + (minute*60)
      let total_km_effort = 0
      let count_cp = 0
      let previous_cutoff = 0
      let accum_slowest = 0
      let km_effort_manual = 0
      let time_manual = 0
      let slowest_manual = 0
      let second_diff = 0
      let annotation, distance, inter_d, km_effort, totalSeconds
      this.runner_start = ((this.runner_start_hour-this.original_start_hour)*60*60) + ((this.runner_start_minute-this.original_start_minute)*60)
      //this.runner_start = 900
      console.log(this.runner_start)

      console.log('wow');

      //if(this.annotations[1].slowest_minute){
      if(this.formula_type === 'slowest'){
        //slowest
        console.log('wow2');
        for (let i = 1; i < this.annotations.length; i++) {
          annotation = this.annotations[i]
          accum_slowest = accum_slowest + annotation.segment_slowest_minute
          count_cp = count_cp + 1
          if (this.manual_edit.has(i)){
            //slowest_manual = slowest_manual + annotation.slowest_minute
            //time_manual = time_manual + this.time2seconds(annotation.user_time)
            slowest_manual = 0
            time_manual = 0
          }
          //annotation.cutoff_time
          if(this.annotations[i].cutoff_time){
            totalSeconds = this.time2seconds(this.annotations[i].cutoff_time)-this.runner_start
            let sectionSeconds = totalSeconds-previous_cutoff-time_manual
            let lastCutOffTime = this.annotations[this.annotations.length-1].cutoff_time
            let lastCutOffSecond = this.time2seconds(lastCutOffTime)-this.runner_start
            let sectionTimeRatio = sectionSeconds / lastCutOffSecond
            for (let j = i; j > i - count_cp; j--) {
              console.log('wow3');
              let user_time = sectionTimeRatio * (this.annotations[j].segment_slowest_minute / (accum_slowest - slowest_manual)) * (target_time-this.runner_start)
              console.log(this.seconds2time(user_time), this.seconds2time(user_time+this.runner_start))
              this.annotations[j].suggested_time = this.seconds2time(user_time)
              if (!this.manual_edit.has(j)){
                this.annotations[j].user_time = this.seconds2time(user_time)

              }
              else{
                second_diff = second_diff + (this.time2seconds(this.annotations[j].suggested_time) - this.time2seconds(this.annotations[j].user_time))
              }
            }
            count_cp = 0
            accum_slowest = 0
            slowest_manual = 0
            time_manual = 0
            previous_cutoff = totalSeconds
          }
        }
        if (second_diff != 0){
          console.log(second_diff)
          console.log(this.annotations.length,this.manual_edit.size,this.annotations.length-1-this.manual_edit.size);
          let per_cp = Math.round(second_diff / (this.annotations.length-1-this.manual_edit.size))
          for (let i = 1; i < this.annotations.length; i++) {
            if (!this.manual_edit.has(i)){
              this.annotations[i].user_time = this.seconds2time(this.time2seconds(this.annotations[i].user_time)+per_cp)
            }
          }
        }
      }else{
        // km/effort
        console.log('wow4');
        for (let i = 1; i < this.annotations.length; i++) {
          annotation = this.annotations[i]
          distance = annotation.accu_distance_cal - this.annotations[i-1].accu_distance_cal
          inter_d = annotation.height_increase
          km_effort = annotation.segment_kme
          total_km_effort = total_km_effort + km_effort
          count_cp = count_cp + 1
          this.annotations[i].km_effort = km_effort
          //annotation.cutoff_time
          if (this.manual_edit.has(i)){
            //km_effort_manual = km_effort_manual + km_effort
            //time_manual = time_manual + this.time2seconds(annotation.user_time)
            km_effort_manual = 0
            time_manual = 0
          }
          if(this.annotations[i].cutoff_time){
            //
            totalSeconds = this.time2seconds(this.annotations[i].cutoff_time)-this.runner_start
            let sectionSeconds = totalSeconds-previous_cutoff-time_manual-900
            console.log(totalSeconds-previous_cutoff-time_manual-900, totalSeconds-previous_cutoff-time_manual)
            let lastCutOffTime = this.annotations[this.annotations.length-1].cutoff_time
            let lastCutOffSecond = this.time2seconds(lastCutOffTime)-this.runner_start
            let sectionTimeRatio = sectionSeconds / lastCutOffSecond
            for (let j = i; j > i - count_cp; j--) {

              var user_time = sectionTimeRatio * (this.annotations[j].km_effort / (total_km_effort - km_effort_manual)) * (target_time-this.runner_start)

              this.annotations[j].suggested_time = this.seconds2time(user_time)
              if (!this.manual_edit.has(j)){
                this.annotations[j].user_time = this.seconds2time(user_time)
              }
              else{
                second_diff = second_diff + (this.time2seconds(this.annotations[j].suggested_time) - this.time2seconds(this.annotations[j].user_time))
              }
            }
            count_cp = 0
            total_km_effort = 0
            km_effort_manual = 0
            time_manual = 0
            previous_cutoff = totalSeconds
          }
        }
        if (second_diff != 0){
          let per_cp = Math.round(second_diff / (this.annotations.length-1-this.manual_edit.size))
          for (let i = 1; i < this.annotations.length; i++) {
            if (!this.manual_edit.has(i)){
              this.annotations[i].user_time = this.seconds2time(this.time2seconds(this.annotations[i].user_time)+per_cp)
            }
          }
        }
      }

      //เสร็จแล้วเรียกฟังก์ชั่นข้างล่าง
      this.calculateUserTime()
      this.calculateNutrients()

      console.log(this.currentStep)
      if(this.currentStep === 1){
        this.setStep(2)
      }
    },

    calculateRunnerChartIcon(){
      let target_time = (this.total_hour*60*60) + (this.total_minute*60)
      let step = 300
      this.predict_times_key = []
      /*Show runner on chart*/
      let times = []
      for (let i = 0; i < target_time; i+= step) {
        times.push(i)
      }
      if(times.indexOf(target_time) < 0){
        times.push(target_time)
      }
      times.sort(function(a,b) { return a - b })
      this.predict_times_key = times
      this.predict_distance_by_time()
      this.changeTimeRange(false)
    },

    predict_distance_by_time(type='you'){
      if(!(this.total_hour || this.total_minute > 0)){
        return
      }
      if(this.annotations.length == 0){
        return
      }
      let type_trans = {'you': {'attr': 'user_race_time'}, 'first': {'attr': 'fastest_minute'}, 'last': {'attr': 'slowest_minute'}}
      let pacers = this.category.pacer_title ?? []
      for (let i = 0; i < pacers.length; i++) {
        if(pacers[i]){
          type_trans[pacers[i]] = {'attr': 'pacer_minute_'+(i+1)}
        }
      }
      let predicts = {}
      let now_idx = 0
      let next_idx = 1
      let now_sec = 0, next_sec=0
      if(type=='you'){
        now_sec = this.time2seconds(this.annotations[now_idx].user_race_time)
        next_sec = this.time2seconds(this.annotations[next_idx].user_race_time)
      }else if(type !== 'you'){
        now_sec = (this.annotations[now_idx][type_trans[type].attr] ?? 0) * 60
        next_sec = (this.annotations[next_idx][type_trans[type].attr] ?? 0) * 60
      }
      let found = -1
      for (const time of this.predict_times_key) {
        //Please perform your calculation here
        if(time > next_sec && next_idx < this.annotations.length-1){
          found = -1
          for (let i = 0; i < this.annotations.length; i++) {
            let temp_sec = 0
            if(type=='you'){
              temp_sec = this.time2seconds(this.annotations[i].user_race_time)
            }else if(type !== 'you'){
              temp_sec = (this.annotations[i][type_trans[type].attr] ?? 0) * 60
            }
            if(time < temp_sec){
              found = 1
              now_idx = i - 1
              next_idx = i
              break
            }
          }
          if(found === -1){
            now_idx = this.annotations.length - 2
            next_idx = this.annotations.length - 1
          }
          if(type=='you'){
            now_sec = this.time2seconds(this.annotations[now_idx].user_race_time)
            next_sec = this.time2seconds(this.annotations[next_idx].user_race_time)
          }else if(type !== 'you'){
            now_sec = (this.annotations[now_idx][type_trans[type].attr] ?? 0) * 60
            next_sec = (this.annotations[next_idx][type_trans[type].attr] ?? 0) * 60
          }
        }
        predicts[time] = this.annotations[now_idx].accu_distance_cal + ((time - now_sec) * (this.annotations[next_idx].segment_distance/ ( next_sec - now_sec )))
        if(predicts[time] > this.annotations[next_idx].accu_distance_cal){
          predicts[time] = this.annotations[next_idx].accu_distance_cal
        }
      }
      this.predict_times[type] = predicts
      for (const runner_type in type_trans) {
        if(type === "you" && (!(runner_type in this.predict_times) || Object.keys(this.predict_times[runner_type]).length === 1)){
          this.predict_distance_by_time(runner_type)
        }
      }
    },

    calculateNutrients(){
      let total_nutrients = {water:0, calories:0, sodium:0, potassium:0, carbohydrate:0, protein:0}
      let annotations = JSON.parse(JSON.stringify(this.chart_elevation_options_original)).annotations
      for (let i = 1; i < this.annotations.length; i++) {
        let annotation = this.annotations[i]
        let speed = this.pace2speed(this.time2seconds('00:'.concat(annotation.pace)))
        let required_cal = Math.round((1.5*this.runnerWeight) +
            (2*(this.runnerWeight + this.backpackWeight)*Math.pow(this.backpackWeight/this.runnerWeight, 2)) +
            ((this.runnerWeight + this.backpackWeight)*((1.5*Math.pow(speed, 2) + (0.35*speed*this.grade))))) *
          ( 0.860421 * this.time2hours(annotation.user_time))
        if(this.annotations[i].nutrients.calories.require != required_cal){
          this.annotations[i].nutrients.calories.require = required_cal
          try {
            this.$refs.chart_elevation.removeAnnotation('cal_' + i)
            this.$refs.chart_elevation.addXaxisAnnotation({
              id: 'cal_' + i,
              x: annotation.x - (annotation.segment_distance * 1000 / 2),
              borderWidth: 0,
              label: {
                borderWidth: 0,
                style: {
                  color: '#e76000',
                  background: "rgba(0,0,0,0)",
                  fontSize: '10px',
                },
                orientation: "horizontal",
                offsetY: 50,
                text: this.annotations[i].nutrients.calories.require.toFixed(0),
                position: "bottom",
              },
            })
          }catch (e) {

          }
        }
        let required_water = this.runnerWeight * (this.time2hours(annotation.user_time)) * 10
        if(this.annotations[i].nutrients.water.require != required_water){
          this.annotations[i].nutrients.water.require = required_water
          try {
            this.$refs.chart_elevation.removeAnnotation('water_' + i)
            this.$refs.chart_elevation.addXaxisAnnotation({
              id: 'water_' + i,
              x: annotation.x - (annotation.segment_distance * 1000 / 2),
              borderWidth: 0,
              label: {
                borderWidth: 0,
                style: {
                  color: '#001abe',
                  background: "rgba(0,0,0,0)",
                  fontSize: '10px',
                },
                orientation: "horizontal",
                offsetY: 60,
                text: this.annotations[i].nutrients.water.require.toFixed(0),
                position: "bottom",
              },
            })
          }catch (e) {

          }
        }
        this.annotations[i].nutrients.sodium.require = (this.time2hours(annotation.user_time)) * 60
        //this.annotations[i].nutrients.magnesium.require = this.runnerWeight * (this.time2hours(annotation.user_time)) * 13
        this.annotations[i].nutrients.potassium.require = (this.time2hours(annotation.user_time)) * 170
        this.annotations[i].nutrients.carbohydrate.require = this.runnerWeight * (this.time2hours(annotation.user_time))
        this.annotations[i].nutrients.protein.require = this.runnerWeight * (this.time2hours(annotation.user_time)) * 0.25

        total_nutrients.water += this.annotations[i].nutrients.water.require
        total_nutrients.calories += this.annotations[i].nutrients.calories.require
        total_nutrients.sodium += this.annotations[i].nutrients.sodium.require
        total_nutrients.potassium += this.annotations[i].nutrients.potassium.require
        total_nutrients.carbohydrate += this.annotations[i].nutrients.carbohydrate.require
        total_nutrients.protein += this.annotations[i].nutrients.protein.require
      }
      this.total_nutrients = total_nutrients
    },

    autoSuggestNutrient(){
      let index = this.chart_selected_result.index
      let annotation = this.annotations[index]
      let all_foods = []
      let selected = []
      let current_calories = 0
      let goal_calories = annotation.nutrients.calories.require
      let current_water = 0
      let goal_water = annotation.nutrients.water.require
      let current_proportion_cal = 100
      let current_proportion_water = 100
      //let new_best_proportion = 100
      for (const [key, value] of Object.entries(this.station_foods)) {
        all_foods[value['id']] = value
      }
      for (const [key, value] of Object.entries(this.runner_foods)) {
        all_foods[value['id']] = value
      }
      let is_stop = false
      let c = 0
      while(!is_stop){
        c = c + 1
        let temp_best_proportion_cal = current_proportion_cal
        let temp_best_proportion_water = current_proportion_water
        let new_pick = -1
        for (const [key, value] of Object.entries(all_foods)) {
          //let t_best_proportion = (goal_calories - current_calories - value.calories) * 100 / goal_calories
          let t_cal = ( (goal_calories - current_calories - value.calories) * 100 / goal_calories )
          let t_water = ( (goal_water - current_water - value.water) * 100 / goal_water )
          let t_best_proportion = ( t_cal + t_water ) / 2

          if(Math.abs(t_cal) < Math.abs(temp_best_proportion_cal) || Math.abs(t_water) < Math.abs(temp_best_proportion_water)  ){
            temp_best_proportion_cal = t_cal
            temp_best_proportion_water = t_water
            new_pick = key
          }
        }
        // 3 1 2
        if (new_pick !== -1 && (Math.abs(temp_best_proportion_cal) < Math.abs(current_proportion_cal) || Math.abs(temp_best_proportion_water) < Math.abs(current_proportion_water)) ){
          selected.push(new_pick)
          current_proportion_cal = temp_best_proportion_cal
          current_proportion_water = temp_best_proportion_water
          current_calories = current_calories + all_foods[new_pick].calories
          current_water = current_water + all_foods[new_pick].water
        }
        else{
          is_stop = true
        }
        if (c >= 20){
          is_stop = true
        }
      }

      let count_selected = {}
      for (const [key, value] of Object.entries(selected)) {
        if (count_selected.hasOwnProperty(value)) {
          count_selected[value] = count_selected[value] + 1
        } else {
          count_selected[value] = 1
        }
      }
      for (const [key, value] of Object.entries(all_foods)) {
        if (count_selected.hasOwnProperty(value['id'])) {
          this.setFoodQty(value['id'], count_selected[value['id']], index)
        } else {
          this.setFoodQty(value['id'], 0, index)
        }
      }
    },

    time2hours(time) {
      //return Math.round(this.time2seconds(time)/(60*60))
      return this.time2seconds(time)/(60*60)
    },

    pace2speed(pace) {
      return 1000/pace
    },

    calculateUserTime() {
      //let totalSecond = 0
      this.runner_start = ((this.runner_start_hour-this.original_start_hour)*60*60) + ((this.runner_start_minute-this.original_start_minute)*60)
      let totalSecond = this.runner_start
      // Split timestamp into [ Y, M, D, h, m, s ]
      let t = this.category.start_date.split(/[- :]/)
      let is_user_times_filled = true
      for (let i = 0; i < this.annotations.length; i++) {
        this.annotations[i].user_time = this.seconds2time(this.time2seconds(this.annotations[i].user_time)).slice(0,5)
        if(i > 0 &&this.annotations[i].user_time === '00:00'){
          is_user_times_filled = false
        }
        this.annotations[i].pace = this.calculatePace(this.annotations[i].user_time, this.annotations[i].segment_distance)
        this.user_times[this.annotations[i].id] = {
          'time': this.time2seconds(this.annotations[i].user_time),
          'manual_edit':this.manual_edit.has(i),
          'pace': this.time2seconds("00:"+this.annotations[i].pace),
        }
        totalSecond += this.time2seconds(this.annotations[i].user_time)
        this.annotations[i].user_race_time = this.seconds2time(totalSecond).slice(0, 5)
        let world_time
        if(this.original_start_hour !== this.start_hour || this.original_start_minute !== this.start_minute){
          world_time = new Date(t[0], t[1]-1, t[2], this.start_hour, this.start_minute, t[5])
        }else{
          world_time = new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5])
          //world_time = new Date(t[0], t[1]-1, t[2], this.runner_start_hour, this.runner_start_minute, t[5])
          console.log('y')
          console.log(this.runner_start_hour)
          console.log(this.runner_start_minute)
        }
        world_time = world_time.addSeconds(totalSecond)
        this.annotations[i].user_world_time_mysql = world_time.toMySQLFormat()
        this.annotations[i].user_world_time = world_time.toMySQLFormat().slice(11, 16)
        this.annotations[i].margin = 0
        console.log('z')
        console.log(this.annotations[i].user_world_time)
        console.log(this.annotations[i].world_time)
        if(this.annotations[i].cutoff_time){
          this.annotations[i].margin = this.time2seconds(this.annotations[i].cutoff_time) + this.start_diff_seconds - this.time2seconds(this.annotations[i].user_race_time)
        }
        let days
        if(this.$locale() == 'en'){
          days = ['SUN','MON','TUE','WED','THU','FRI','SAT']
        } else if(this.$locale() == 'th'){
          days = ['อา.','จ.','อ.','พ.','พฤ.','ศ.','ส.']
        }
        this.annotations[i].user_world_day = days[world_time.getDay()]
        //edit chart world time
        try {
          this.$refs.chart_elevation.removeAnnotation('worldtime_' + i)
          this.$refs.chart_elevation.addXaxisAnnotation({
            id: 'worldtime_' + i,
            x: this.annotations[i].x,
            borderWidth: 0,
            label: {
              borderWidth: 0,
              style: {
                color: '#000000',
                background: "rgba(0,0,0,0)",
              },
              orientation: "horizontal",
              offsetY: 24,
              text: this.annotations[i].user_world_time,
              position: "bottom",
            },
          })
          this.$refs.chart_elevation.removeAnnotation('worldday_' + i)
          this.$refs.chart_elevation.addXaxisAnnotation({
            id: 'worldday_' + i,
            x: this.annotations[i].x,
            borderWidth: 0,
            label: {
              borderWidth: 0,
              style: {
                color: '#000000',
                background: "rgba(0,0,0,0)",
                fontSize: '10px',
              },
              orientation: "horizontal",
              offsetY: 36,
              text: this.annotations[i].user_world_day,
              position: "bottom",
            },
          })
        }catch (e) {
          console.log(e)
        }
      }
      this.is_user_times_filled = is_user_times_filled
      if(this.annotations.length > 0){
        this.chart_avg_pace = this.calculatePace(this.annotations[this.annotations.length-1].user_race_time, this.annotations[this.annotations.length-1].accu_distance_cal)
      }
      for (let i = 0; i < this.annotations.length; i++) {
        this.get_weather_forecast(i)
      }
      this.calculateRunnerChartIcon()
      this.updateChartInput()
      this.savePlan()
    },


    async get_weather_forecast(i){
      try {
        this.$refs.chart_elevation.removeAnnotation('temperature_' + i)
      }
      catch (e) {}
      try {
        this.$refs.chart_elevation.removeAnnotation('weather_icon_' + i)
      }
      catch (e) {}
      try{
        this.annotations[i].user_weather_data = null
        this.annotations[i].user_weather_source = null
        let slug = this.event.slug
        let anno = this.annotations[i]
        if(!anno.user_world_time_mysql){
          return
        }
        let temp = anno.user_world_time_mysql.split(" ")
        let date = temp[0], time = temp[1]
        const data = {'slug': slug, 'ecc_id': anno.id, date: date, time:time }
        const response = await axios.post(route('get_weather_forecast', []).url(), data)
        if(!response.data.status){
          console.log(response.data.message)
          return
        }
        this.annotations[i].user_weather_data = response.data.data[0]
        this.annotations[i].user_weather_source = response.data.source
        let tooltip_text = ''
        tooltip_text += response.data.data[0].weather[0].description + '<br>'+ this.$trans('raceplan.event_category.temp') +' '+response.data.data[0].temp.toFixed(1) + '°C<br>' + this.$trans('raceplan.event_category.feels_like') +' '+response.data.data[0].feels_like.toFixed(1)+'°C'
        if(response.data.source == 'historical'){
          tooltip_text += '<br><br>(Last Year Data)'
        }
        let exampleTriggerEl = document.getElementById('weather_tooltip_'+i)
        let tooltip = Tooltip.getOrCreateInstance(exampleTriggerEl,{
          html: true,
          title: tooltip_text,
        })
        tooltip._config.title = tooltip_text
        exampleTriggerEl = document.getElementById('weather_tooltip_2_'+i)
        tooltip = Tooltip.getOrCreateInstance(exampleTriggerEl,{
          html: true,
          title: tooltip_text,
        })
        tooltip._config.title = tooltip_text
        if(i > 0){
          this.$refs.chart_elevation.addXaxisAnnotation({
            id: 'temperature_' + i,
            x: anno.x,
            borderWidth: 0,
            label: {
              borderWidth: 0,
              style: {
                color: '#000000',
                background: "rgba(0,0,0,0)",
                fontSize: '10px',
              },
              orientation: "horizontal",
              offsetY: -35,
              text: response.data.data[0].temp.toFixed(1) + '°C',
              position: "top",
            },
          })
          let path = '/asset/image/weather_icon/'+response.data.data[0].weather[0].icon+'.svg'
          this.$refs.chart_elevation.addPointAnnotation ({
            id: 'weather_icon_' + i,
            x: anno.x,
            y: null,
            marker: {
              size: 0
            },
            image: {
              path: path,
              width: 20,
              height: 20,
              offsetY: -55
            }
          })
        }
        let text = '<strong>'+anno['title_'+this.$locale()]
        if(anno.code){
          text = anno.code + ' - ' + text
        }
        text += '</strong><div class="text-center">'
        text += '<br>'+this.$trans('raceplan.event_category.weather_arrival')
        text += '<br><img style="width: 50px;" src="'+'/asset/image/weather_icon/'+response.data.data[0].weather[0].icon+'.svg'+ '">'
        text += '<br>'+this.$trans('raceplan.event_category.temp')+ ' ' +response.data.data[0].temp.toFixed(1) + '°C'
        text += '<br>'+this.$trans('raceplan.event_category.feels_like')+ ' ' +response.data.data[0].feels_like.toFixed(1) + '°C'
        if(response.data.source == 'historical'){
          text += '<br><br>('+this.$trans('raceplan.event_category.weather_remark')+')'
        }
        text += '</div>'
        text += '<br><br><a target="_blank" href="https://www.google.com/maps/search/?api=1&query='+anno.lat+'%2C'+anno.lon+'">'+this.$trans('raceplan.event_category.travel_to')+'</a>'
        this.marker[i].setPopupContent(text)
      }catch(error){
        if(error.response && error.response.data && error.response.data.message){
          alert(error.response.data.message)
        }else{
          console.log(error)
        }
      }
    },

    async savePlan() {
      if(!this.shouldInitCalculatePlan){
        this.shouldInitCalculatePlan = true
        return
      }
      if(!this.$page.props.auth.loggedIn){
        return
      }
      try{
        const data = {'total_hour': this.total_hour, 'total_minute': this.total_minute, 'plan': JSON.parse(JSON.stringify(this.user_times)), 'start_hour': this.start_hour, 'start_minute': this.start_minute,
          'runner_weight': this.runnerWeight, 'backpack_weight': this.backpackWeight,
          'runner_start_hour': this.runner_start_hour, 'runner_start_minute': this.runner_start_minute,
        }
        const response = await axios.post(route('events.save_plan', [this.event.slug, this.category.slug]).url(), data)
      }catch(error){
        if(error.response && error.response.data && error.response.data.message){
          alert(error.response.data.message)
        }else{
          console.log(error)
        }
      }
    },

    seconds2time(secs){
      let sec_num = parseInt(secs, 10)
      let hours   = Math.floor(sec_num / 3600)
      let minutes = Math.floor(sec_num / 60) % 60
      let seconds = sec_num % 60

      return [hours,minutes,seconds]
          .map(v => v < 10 ? "0" + v : v)
          .join(":")
    },

    time2seconds(time){
      let h = 0,m = 0,s = 0
      let temp = time.split(':')
      if(temp.length > 2){
        h = parseInt(temp[0])
        m = parseInt(temp[1])
        s = parseInt(temp[2])
      }else{
        h = parseInt(temp[0])
        m = parseInt(temp[1])
      }
      return (h*3600)+(m*60)+s
    },

    //distance = km.
    calculatePace(time, distance){
      let totalSeconds = this.time2seconds(time)
      let totalMinutes = totalSeconds / 60,
          pace = totalMinutes / distance,
          paceMinutes = Math.floor(pace),
          paceSeconds = Math.round((pace - paceMinutes) * 60)
      if(paceSeconds < 10) {
        paceSeconds = "0" + paceSeconds
      }
      return paceMinutes + ":" + paceSeconds
    },

    pace2time(pace, distance_km){
      let minute = parseInt(pace.split(':')[0])
      let second = parseInt(pace.split(':')[1])
      let paceSecond = (minute*60)+second
      let total_second = paceSecond * distance_km
      return this.seconds2time(total_second)
    },

    async parseGPX(){
      let that = this
      let gpx_url = this.category.gpx_url
      try {
        let res = await axios.get(gpx_url)
        let xml = res.data
        var gpx = new gpxParser(); //Create gpxParser Object
        gpx.parse(xml)
        let points = gpx.tracks[0].points
        let cumul = gpx.tracks[0].distance.cumul
        let geo_list = []
        for (let i = 0; i < gpx.tracks[0].points.length; i++) {
          if(points[i].ele){
            geo_list.push({'lat': points[i].lat, 'lon': points[i].lon, 'ele': points[i].ele, 'dis': cumul[i]})
          }
        }
        if(geo_list.length === 0){
          for (let i = 0; i < gpx.tracks[0].points.length; i++) {
            geo_list.push({'lat': points[i].lat, 'lon': points[i].lon, 'ele': 0, 'dis': cumul[i]})
          }
        }
        this.geo_list = geo_list
        let altitude_list = []
        let distance2d_list = []
        for (let i = 0; i < this.geo_list.length; i++) {
          distance2d_list.push(this.geo_list[i].dis)
          altitude_list.push(this.geo_list[i].ele)
        }
        // start sampling list
        let expected_point = 800
        let count_distance2d_orginal = distance2d_list.length
        let divide_value = Math.max(1, Math.floor(count_distance2d_orginal/expected_point))
        let first_ele = altitude_list[0]
        let new_distance2d = []
        let new_altitude_list = []
        for(let i = count_distance2d_orginal-1; i >= 0; i -= divide_value){
          new_distance2d.push(distance2d_list[i])
          new_altitude_list.push(altitude_list[i])
        }

        new_distance2d.reverse()
        new_altitude_list.reverse()
        distance2d_list = new_distance2d
        distance2d_list[0] = 0
        altitude_list = new_altitude_list
        altitude_list[0] = first_ele
        //end sampling list

        //total_icons = ["drink", "rest", "toilet", "shuttlebus", "snack", "shower", "medical", "assistant", "food", "sparebag"]
        this.drawChart('chart', this.category['title_'+this.$locale()], distance2d_list, altitude_list)
        setTimeout(function (){
          if(that.$page.props.auth.loggedIn && that.shouldInitCalculatePlan){
            that.calculatePlan()
          }
          else if(that.$page.props.auth.loggedIn && !that.shouldInitCalculatePlan){
            that.calculateUserTime()
          }
          that.calculateNutrients()
          that.changeTimeRange(false)
        }, 1000)
      } catch (error) {
        console.log(error)
      }
    },

    drawChart(chartID, chartTitle, distance2d_list, altitude_list){
      let lineSeries = []
      let that = this
      for (let i = 0; i < distance2d_list.length; i++) {
        lineSeries.push([distance2d_list[i], altitude_list[i]])
      }

      let annotations_xaxis = []
      let annotations_point = []
      let max_altitude = altitude_list.reduce((a, b) => Math.max(a, b), -Infinity)
      max_altitude = Math.max(400, max_altitude*1.3)
      let min_altitude = altitude_list.reduce((a, b) => Math.min(a, b), Infinity)
      min_altitude = Math.min(100, min_altitude/1.3)
      for (const key in this.category.point_of_interests) {

        let poi = this.category.point_of_interests[key]
        let arm_length = poi.arm_length ? poi.arm_length : 40
        let poi_anno = {
          x: poi.x,
          strokeDashArray: 5,
          borderColor: '#b0b0b0',
          label: {
            borderColor: false,
            style: {
              background: 'transparent',
            },
            text: '',
          },
        }
        annotations_xaxis.push(poi_anno)
        let point = {
          x: poi.x,
          y: poi.y,
          marker: {
            size: 0,
          },
          label: {
            borderColor: false,
            style: {
              color: poi['color'],
              background: 'transparent',
            },
            text: poi['title_'+this.$locale()],
          },
        }
        if(poi.position == 'top'){
          point['label']['offsetY'] = (-1*arm_length) + 3
        }else{
          point['label']['offsetY'] = arm_length + 20
        }
        annotations_point.push(point)
      }
      for (let i = 0; i < annotations_point.length; i++) {
        let point = this.findPointByDistance(annotations_point[i]["x"])
        annotations_point[i]["y"] = point.ele
      }
      annotations_xaxis.push({
        id: 'temperature_title',
        x: this.annotations[0].x,
        borderWidth: 0,
        label: {
          borderWidth: 0,
          style: {
            color: '#000000',
            background: "rgba(0,0,0,0)",
            fontSize: '10px',
          },
          orientation: "horizontal",
          offsetY: -35,
          text: "Temp.",
          position: "top",
        },
      })
      annotations_xaxis.push({
        id: 'cal_title',
        x: this.annotations[0].x,
        borderWidth: 0,
        label: {
          borderWidth: 0,
          style: {
            color: '#e76000',
            background: "rgba(0,0,0,0)",
            fontSize: '10px',
          },
          orientation: "horizontal",
          offsetY: 50,
          text: "CAL",
          position: "bottom",
        },
      })
      annotations_xaxis.push({
        id: 'water_title',
        x: this.annotations[0].x,
        borderWidth: 0,
        label: {
          borderWidth: 0,
          style: {
            color: '#001abe',
            background: "rgba(0,0,0,0)",
            fontSize: '10px',
          },
          orientation: "horizontal",
          offsetY: 60,
          text: "Water(ml.)",
          position: "bottom",
        },
      })
      for(let i=1; i<this.annotations.length;i++){
        let annotation = this.annotations[i]
        for(let j=0; j<annotation.subset.length;j++) {
          let sub_anno = annotation.subset[j]
          annotations_xaxis.push({
            x: sub_anno.x,
            strokeDashArray: 10,
            borderColor: sub_anno.color,
            label: {
              borderWidth: 0,
              style: {
                color: '#000000',
                background: "rgba(0,0,0,0)",
                fontWeight: 800,
              },
              orientation: "horizontal",
              text: sub_anno.text,
              position: "bottom",
            },
          })
        }
        if(i !== this.annotations.length-1 && annotation.code){
          annotations_xaxis.push({
            x: annotation.x,
            borderColor: annotation.color,
            borderWidth: 0,
            label: {
              borderWidth: 0,
              style: {
                color: '#000000',
                background: "rgba(0,0,0,0)",
              },
              orientation: "horizontal",
              offsetY: 12,
              text: Math.round(annotation.accu_distance_cal)+this.$trans('raceplan.event_category.km'),
              position: "bottom",
            },
          })
        }
        if(annotation.icons){
          for(let ii=0; ii<annotation.icons.length; ii++){
            let icon_name = annotation.icons[ii]
            let path = '/icon/replace_here.png'
            path = path.replace('replace_here', icon_name)
            annotations_point.push({
              x: annotation.x,
              y: max_altitude,
              marker: {
                size: 0
              },
              image: {
                path: path,
                width: 15,
                height: 15,
                offsetY: 15*ii
              }
            })
          }
        }
        if(annotation.cutoff_time){
          annotations_xaxis.push({
            x: annotation.x,
            borderWidth: 0,
            textAnchor: 'middle',
            label: {
              borderWidth: 0,
              style: {
                color: '#ff0000',
                background: "rgba(0,0,0,0)",
                fontSize: '10px',
              },
              orientation: "vertical",
              offsetY: -36,
              text: 'CUT '+annotation.world_time+' '+annotation.world_day,
              position: "bottom",
            },
          })
        }
      }
      let series = [{
        name: "Elevation",
        data: lineSeries
      }]
      let options = {
        colors:['#58714a'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        title: {
          text: chartTitle,
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#9be9ff', '#9be9ff'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
          padding: {
            top: 50,
            right: 25,
            bottom: 65,
            left: 0,
          },
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return value.toFixed(0) + " m."
            }
          },
          max: max_altitude,
          min: min_altitude,
          tickAmount: 7,
        },
        xaxis: {
          type: 'numeric',
          tickPlacement: 'on',
          labels: {
            show: false,
            formatter: function (value) {
              return (value/1000).toFixed(1) + that.$trans('raceplan.event_category.km')
            },
          },
          tickAmount: 5
        },
        annotations: {
          xaxis: annotations_xaxis,
          points: annotations_point,
        },
        chart: {
          id: 'chart',
          offsetY: 20,
          events: {
            click: function (event, chartContext, config) {
              let selected_distance = distance2d_list[config.dataPointIndex]
              let result = that.findRange(selected_distance, that.annotations)
              that.rowClicked(result.index)
            },
          },
          redrawOnParentResize: true,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            gradientToColors: ['#aac496'],
            stops: [0, 90, 100],
          },
        }
      }

      if(!this.chart_elevation_options_original || !this.chart_elevation_options_original.annotations){
        this.chart_elevation_options_original = JSON.parse(JSON.stringify(options))
      }
      this.isShowChart = true
      this.chart_elevation_series = series
      this.chart_elevation_options = options


      if(this.currentStep === 1 && this.search_uid){
        $(document).ready(function(){
          //console.log('readyyy');
          const boarding = new Boarding({
            scrollIntoViewOptions: {
              behaviour: "smooth",
            },
          });
          boarding.highlight({
            element: ".target_time_input",
            popover: {
              title: that.$trans('raceplan.event_category.set_your_goal'),
              description: that.$trans('raceplan.event_category.free_photo_instruction2'),
              // prefferedSide can be left, right, top, bottom
              prefferedSide: "bottom",
              // alignment can be start, center, right
              alignment: "center",
            },
          });

          document.onclick = function(){
            // your code
            if (boarding.isActivated) {
              boarding.reset(false);
            }
          }
        })
      }

    },

    rowClicked(index, state="auto"){
      if(!this.$page.props.auth.loggedIn && false){
        alert(this.$trans('auth.login_check'))
        return
      }
      this.chart_selected_result = null
      try {
        this.$refs.chart_elevation.removeAnnotation('selected_range')
        this.chart_accu_time = ''
        if(index > 0){
          if (state === 'select' ||  state === 'auto'){
            let result = this.findRange(this.annotations[index].x, this.annotations)
            this.chart_selected_result = result
            this.$refs.chart_elevation.addXaxisAnnotation({
              id: 'selected_range',
              x: result.range[0],
              x2: result.range[1],
              fillColor: '#B3F7CA',
              opacity: 0.4,
            })
            this.updateChartInput()
          }
        }else{
          let result = this.findRange(this.annotations[index].x, this.annotations)
          this.chart_selected_result = result
          this.chart_selected_result.index = 0
        }
      }catch (e) {}
    },

    findPointByDistance(distance){
      /* distance(cm.) */
      if(distance == 0){
        return this.geo_list[0]
      }
      let now_point = null
      for (const point of this.geo_list) {
        if(point.dis < distance){
          now_point = point
        }else{
          break
        }
      }
      return now_point
    },

    updateChartInput(){
      if(this.chart_selected_result){
        this.time_hour = this.annotations[this.chart_selected_result.index].user_time.slice(0,2)
        this.time_minute = this.annotations[this.chart_selected_result.index].user_time.slice(3,5)
        let pace = this.calculatePace(this.annotations[this.chart_selected_result.index].user_time, this.chart_selected_result.annotation.segment_distance)
        this.pace_minute = pace.split(':')[0]
        this.pace_second = pace.split(':')[1]
        this.chart_accu_time = this.annotations[this.chart_selected_result.index].user_race_time
      }
    },

    closeKeyboard(){
      this.$refs.input.blur();
      console.log("yeah");
    },

    changeTimeInput(){
      if(this.chart_selected_result){
        if(!this.time_hour){
          this.time_hour = '00'
        }
        if(!this.time_minute){
          this.time_minute = '00'
        }
        this.time_hour += ''
        this.time_minute += ''
        let new_time = this.time_hour.trim()+':'+this.time_minute.trim()
        let km = (this.chart_selected_result.range[1]-this.chart_selected_result.range[0])/1000
        let new_pace = this.calculatePace(new_time, km)
        this.pace_minute = new_pace.split(':')[0]
        this.pace_second = new_pace.split(':')[1]
        this.manual_edit.add(this.chart_selected_result.index)
        this.annotations[this.chart_selected_result.index].user_time = new_time
        this.calculatePlan()

        //XXX
        console.log(this.search_uid);
        console.log("x");
        /*
        if(this.search_uid){
          const boarding = new Boarding();
          boarding.highlight({
            element: "#step-2",
            popover: {
              title: "Congrats!",
              description: "<p>And it’s done! We’ve planned your race time based on various criteria.<br>\n" +
                  "<strong>Now, you can scroll down to download and share your photos!</strong> <br>\n" +
                  "We hope you enjoy the race!<br>\n" +
                  "<br>\n" +
                  "Additionally:<br>\n" +
                  "If you feel you can improve in any area or if something seems too difficult, you can adjust your time by clicking on each checkpoint.<br>\n" +
                  "You can also explore the nutrition plan we’ve created for you in the next section.<p>",
              // prefferedSide can be left, right, top, bottom
              prefferedSide: "bottom",
              // alignment can be start, center, right
              alignment: "center",
            },
          });
          boarding.start();
          console.log("Y");
        }
        */
      }
    },

    changePaceInput(){
      if(this.chart_selected_result){
        if(!this.pace_minute){
          this.pace_minute = '0'
        }
        if(!this.time_minute){
          this.pace_second = '00'
        }
        this.pace_minute += ''
        this.pace_second += ''
        let km = (this.chart_selected_result.range[1]-this.chart_selected_result.range[0])/1000
        let new_pace = this.pace_minute.trim()+':'+this.pace_second.trim()
        let new_time = this.pace2time(new_pace, km)
        this.time_hour = new_time.slice(0,2)
        this.time_minute = new_time.slice(3,5)
        this.manual_edit.add(this.chart_selected_result.index)
        this.annotations[this.chart_selected_result.index].user_time = new_time
        this.calculatePlan()
      }
    },

    changeStartInput(){
      this.start_diff_seconds = ((this.original_start_hour - this.start_hour) * 3600) + ((this.original_start_minute - this.start_minute) * 60)
      this.calculatePlan()
    },

    changeWeight(){
      this.calculateNutrients()
      this.savePlan()
    },

    changeFoodQty(food_id, qty, index=null){
      if(!index){
        index = this.chart_selected_result.index
      }
      let max = 99
      if(this.station_foods[food_id]){
        max = this.station_foods[food_id].max
      }
      if(this.annotations[index].foods[food_id].qty + qty >= 0 && this.annotations[index].foods[food_id].qty + qty <= max){
        this.setFoodQty(food_id,this.annotations[index].foods[food_id].qty + qty, index)
      }
    },

    async setFoodQty(food_id, qty, index){
      const data = {food_id: food_id, amount: qty, checkpoint_id: this.annotations[index].checkpoint_id}
      const response = await axios.post(route('events.set_menu_quantity', [this.event.slug, this.category.slug]).url(), data)
      if(!response.data.status){
        alert(response.data.message)
        return
      }
      this.annotations[index].foods[food_id].qty = qty
      let food
      if(this.station_foods[food_id]){
        food = this.station_foods[food_id]
      }else if(this.runner_foods[food_id]){
        food = this.runner_foods[food_id]
      }else{
        food = this.tiein_foods[food_id]
      }
      //calculate nutrient
      for (const nutrient in this.annotations[index].nutrients) {
        this.annotations[index].foods[food_id][nutrient] = food[nutrient] * this.annotations[index].foods[food_id].qty
        this.annotations[index].foods[food_id][nutrient] = (+(Math.round((this.annotations[index].foods[food_id][nutrient]) + "e+2")  + "e-2"))

        let sum = 0;
        for (const food_id2 in this.annotations[index].foods) {
          sum += this.annotations[index].foods[food_id2][nutrient]
        }
        this.annotations[index].nutrients[nutrient].current = sum
      }
    },

    toggleManualEdit(index){
      if(this.manual_edit.has(index)){
        this.manual_edit.delete(index)
        this.rowClicked(index, 'deselect')
        this.calculatePlan()
      }else{
        this.manual_edit.add(index)
        this.rowClicked(index, 'select')
      }
    },

    async addNewMenu(){
      this.is_validate_menu = true
      if(!this.input_menu_name){
        return
      }
      this.is_validate_menu = false
      let new_food = {
        id: Object.keys(this.runner_foods).map(function (x) {
          return parseInt(x, 10);
        }).sort().reverse()[0]+1,
        title_en: this.input_menu_name,
        title_th: this.input_menu_name,
      }
      for (const [key, value] of Object.entries(this.input_menu_nutrients)) {
        new_food[key] = parseFloat(value)
        this.input_menu_nutrients[key] = 0
      }
      const data = new_food
      const response = await axios.post(route('events.add_menu', [this.event.slug, this.category.slug]).url(), data)
      if(!response.data.status){
        alert(response.data.message)
        return
      }
      new_food = response.data.menu
      for (let i = 0; i < this.annotations.length; i++) {
        this.annotations[i].foods[new_food.id] = {qty:0}
      }
      this.runner_foods[new_food.id] = new_food
      this.input_menu_name = ''
    },

    async removeMenu(food_id){
      var r = confirm("Confirm remove this menu? This will remove menu from every checkpoint.");
      if (r == true) {
        const data = {food_id: food_id}
        const response = await axios.post(route('events.remove_menu', [this.event.slug, this.category.slug]).url(), data)
        if(!response.data.status){
          alert(response.data.message)
          return
        }
        for (let i = 0; i < this.annotations.length; i++) {
          delete this.annotations[i].foods[food_id]
        }
        delete this.runner_foods[food_id]
      }
    },
    printClicked(orientation = 'p'){
      let that = this
      this.$refs.chart_elevation.dataURI().then(({ imgURI, blob }) => {
        var image = new Image();
        image.onload = function(){
          const doc = jsPDF(orientation, 'mm', 'a4')
          doc.setFont("THSarabunNew")
          let ratio = image.width/image.height
          let doc_width = doc.internal.pageSize.getWidth()
          let img_width = doc_width-24
          let height = img_width / ratio
          doc.addImage(imgURI, 'PNG', 12, 5, img_width, height)

          let head = [
            [
              {content: 'Info', colSpan: 7, styles: {fillColor: [216, 234, 210]}},
              {content: 'Section Plan', colSpan: 5, styles: {fillColor: [133, 213, 255]}},
            ],
            [
              {content: 'World\nTime', styles: {fillColor: [216, 234, 210]}},
              {content: 'Mark', styles: {fillColor: [216, 234, 210]}},
              {content: 'Dist.', styles: {fillColor: [216, 234, 210]}},
              {content: 'Accu.\nDist.', styles: {fillColor: [216, 234, 210]}},
              {content: 'Cut\nOff', styles: {fillColor: [216, 234, 210]}},
              {content: 'Elev.\nGain', styles: {fillColor: [216, 234, 210]}},
              {content: 'Elev.\nLoss', styles: {fillColor: [216, 234, 210]}},
              {content: 'Pace', styles: {fillColor: [133, 213, 255]}},
              {content: 'Time', styles: {fillColor: [133, 213, 255]}},
              {content: 'Race\nTime', styles: {fillColor: [133, 213, 255]}},
              {content: 'World\nTime', styles: {fillColor: [133, 213, 255]}},
              {content: 'Margin', styles: {fillColor: [133, 213, 255]}},
            ],
          ]
          let body = [], body2 = []
          for (let i = 0; i < that.annotations.length; i++) {
            let annotation = that.annotations[i]
            let height_color = {increase: [0, 0, 0], decrease: [0, 0, 0]}
            for (const type in height_color) {
              if (annotation['height_' + type] >= 400 && annotation['height_' + type] < 550) {
                height_color[type] = [255, 195, 2]
              } else if (annotation['height_' + type] >= 550 && annotation['height_' + type] < 700) {
                height_color[type] = [255, 143, 0]
              } else if (annotation['height_' + type] >= 700 && annotation['height_' + type] < 850) {
                height_color[type] = [255, 91, 0]
              } else if (annotation['height_' + type] >= 850) {
                height_color[type] = [255, 5, 5]
              }
            }
            let margin = ''
            if(annotation.cutoff_time && annotation.cutoff_time >= annotation.user_race_time){
              margin = that.seconds2time(that.time2seconds(annotation.cutoff_time) - that.time2seconds(annotation.user_race_time) + that.start_diff_seconds).slice(0,5)
            }else if(annotation.cutoff_time){
              margin = 'CUT'
            }

            if(i === 0){
              body.push([
                {content: that.seconds2time(that.time2seconds(that.start_hour+":"+that.start_minute)).substring(0,5) || '', styles: {}},
                {content: annotation.code || '', styles: {}},
              ])
              body2.push([
                {content: annotation.world_time || '', styles: {}},
                {content: annotation.code || '', styles: {}},
              ])
              continue
            }
            body.push(
                [
                  {content: annotation.world_time || '', styles: {}},
                  {content: annotation.code || '', styles: {}},
                  {content: annotation.segment_distance || '', styles: {}},
                  {content: annotation.accu_distance_cal || '', styles: {}},
                  {content: annotation.cutoff_time || '', styles: {textColor: [255, 0, 0]}},
                  {
                    content: annotation.height_increase || '0',
                    styles: {textColor: height_color.increase}
                  },
                  {
                    content: annotation.height_decrease || '0',
                    styles: {textColor: height_color.decrease}
                  },

                  {content: annotation.pace || '', styles: {}},
                  {content: annotation.user_time.slice(0, 5) || '', styles: {}},
                  {content: annotation.user_race_time || '', styles: {}},
                  {content: annotation.user_world_time || '', styles: {}},
                  {content: margin || '', styles: {}},
                ],
            )

            let menu = []
            for(const [food_id, food] of Object.entries(that.station_foods)){
              if(annotation.foods[food.id] && annotation.foods[food.id].qty > 0){
                menu.push(food['title_'+that.$locale()] + ' x ' + annotation.foods[food.id].qty)
              }
            }
            for(const [food_id, food] of Object.entries(that.runner_foods)){
              if(annotation.foods[food.id] && annotation.foods[food.id].qty > 0){
                menu.push(food['title_'+that.$locale()] + ' x ' + annotation.foods[food.id].qty)
              }
            }
            menu = menu.join('\n')
            body2.push(
                [
                  {content: annotation.world_time || '', styles: {}},
                  {content: annotation.code || '', styles: {}},
                  {content: annotation.segment_distance || '', styles: {}},
                  {content: annotation.accu_distance_cal || '', styles: {}},
                  {content: annotation.cutoff_time || '', styles: {textColor: [255, 0, 0]}},


                  {content: annotation.user_race_time || '', styles: {}},
                  {content: annotation.user_world_time || '', styles: {}},

                  {content: menu, styles: {halign: 'left'}},
                ],
            )
          }
          doc.autoTable({
            theme: 'grid',
            startY: height+10,
            styles: {
              halign: 'center',
              textColor: [0,0,0],
              font: 'THSarabunNew',
              fontStyle: 'normal',
              fontSize: 16,
            },
            head: head,
            body: body,
            pageBreak: 'avoid',
            headStyles: {
              halign: 'center', fontStyle: 'bold',
            },
          })

          let head2 = [
            [
              {content: 'Info', colSpan: 5, styles: {fillColor: [216, 234, 210] }},
              {content: 'Section Plan', colSpan: 2, styles: {fillColor: [133, 213, 255]}},
              {content: 'Menu', rowSpan: 2, styles: {fillColor: [246, 198, 169] }},
            ],
            [
              {content: 'World\nTime', styles: {fillColor: [216, 234, 210]}},
              {content: 'Mark', styles: {fillColor: [216, 234, 210]}},
              {content: 'Dist.', styles: {fillColor: [216, 234, 210]}},
              {content: 'Accu.\nDist.', styles: {fillColor: [216, 234, 210]}},
              {content: 'Cut\nOff', styles: {fillColor: [216, 234, 210]}},

              {content: 'Race\nTime', styles: {fillColor: [133, 213, 255]}},
              {content: 'World\nTime', styles: {fillColor: [133, 213, 255]}},

              {content: 'Menu', styles: {fillColor: [133, 213, 255]}},
            ],
          ]
          doc.line(15, doc.lastAutoTable.finalY + 10, doc_width-15,  doc.lastAutoTable.finalY + 10)
          doc.autoTable({
            theme: 'grid',
            head: head2,
            body: body2,
            startY: doc.lastAutoTable.finalY + 20,
            styles: {
              halign: 'center',
              textColor: [0,0,0],
              font: 'THSarabunNew',
              fontStyle: 'normal',
              fontSize: 16,
            },
            headStyles: {
              halign: 'center', fontStyle: 'bold',
            },
            pageBreak: 'avoid',
          })
          //window.open(doc.output('bloburl', { filename: "Plan.pdf" }))
          doc.save(that.event.title_en+"-"+that.category.title_en+".pdf");
        }
        image.src = imgURI
      })
    },
    isValidHttpUrl(string) {
      let url
      try {
        url = new URL(string)
      } catch (_) {
        return false
      }
      return url.protocol === "http:" || url.protocol === "https:"
    },

    drawMap(){
      let that = this
      let normalPinIcon = L.icon({
        iconUrl: '/asset/image/pin-icon-wpt.png',
        shadowUrl: '/asset/image/pin-shadow.png',
        iconSize:     [24, 32], // size of the icon
        iconAnchor: [12, 32], // point of the icon which will correspond to marker's location
        popupAnchor:  [0, -32], // point from which the popup should open relative to the iconAnchor
        shadowAnchor: [15, 45],
      })
      let startIcon = L.icon({
        iconUrl: '/asset/image/pin-icon-start.png',
        shadowUrl: '/asset/image/pin-shadow.png',
        iconSize:     [24, 32], // size of the icon
        iconAnchor: [12, 32], // point of the icon which will correspond to marker's location
        popupAnchor:  [0, -32], // point from which the popup should open relative to the iconAnchor
        shadowAnchor: [15, 45],
      })
      let finishIcon = L.icon({
        iconUrl: '/asset/image/pin-icon-end.png',
        shadowUrl: '/asset/image/pin-shadow.png',
        iconSize:     [24, 32], // size of the icon
        iconAnchor: [12, 32], // point of the icon which will correspond to marker's location
        popupAnchor:  [0, -32], // point from which the popup should open relative to the iconAnchor
        shadowAnchor: [15, 45],
      })
      let info_marker = {"drink":[], "rest":[], "toilet":[], "shuttlebus":[], "snack":[], "shower":[], "medical":[], "assistant":[], "food":[], "sparebag":[]}
      let icons = {}
      for (const icon in info_marker) {
        icons[icon] = L.icon({
          iconUrl: '/icon/'+icon+'.png',
          shadowUrl: '',
          iconSize:     [24, 24], // size of the icon
          iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
        })
      }
      for (let i = 0; i<this.annotations.length; i++) {
        let annotation = this.annotations[i]
        if(annotation.lat && annotation.lat != 0){
          let marker
          if(annotation.cp_type == "start"){
            marker = L.marker([annotation.lat, annotation.lon], {icon : startIcon})
          }else if(annotation.cp_type == "finish"){
            marker = L.marker([annotation.lat, annotation.lon], {icon : finishIcon})
          }else{
            marker = L.marker([annotation.lat, annotation.lon], {icon : normalPinIcon})
          }
          let title = annotation['title_'+this.$locale()]
          if(!title){
            title = annotation.title_en
          }
          let text = title
          if(annotation.code){
            text = annotation.code + ' - ' + text
          }
          text += '<br><br><a target="_blank" href="https://www.google.com/maps/search/?api=1&query='+annotation.lat+'%2C'+annotation.lon+'">'+that.$trans('raceplan.event_category.travel_to')+'</a>'
          marker.bindPopup(text)
          //marker.on("click", this.rowClicked.bind(null, new_i, "auto"))
          this.marker.push(marker)
          if(annotation.icons){
            for (const icon of annotation.icons) {
              let marker = L.marker([annotation.lat, annotation.lon], {icon : icons[icon]})
              marker.bindPopup(text)
              info_marker[icon].push(marker)
            }
          }
        }
      }
      let Esri_WorldImagery = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
        }),
        Esri_WorldTopoMap = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
        })

      this.checkpoint_layer = L.layerGroup(this.marker)
      this.map = L.map('mapContainer', {
        center: [18.496767, 98.487805],
        zoom: 8,
        layers: [Esri_WorldTopoMap, this.checkpoint_layer],
        fullscreenControl: true,
      })

      let gpx = this.category.gpx_url // URL to your GPX file or the GPX itself
      new L.GPX(gpx, {
        async: true,
        marker_options: {
          startIconUrl: '',
          endIconUrl: '',
          shadowUrl: '',
          wptIconUrls: false,
        },
      }).on('loaded', function(e) {
        that.map.fitBounds(e.target.getBounds())
      }).addTo(that.map)

      let baseMaps = {
        "Esri WorldTopoMap ": Esri_WorldTopoMap,
        "Esri WorldImagery": Esri_WorldImagery,
      };

      let overlayMaps = {
        "Checkpoints": this.checkpoint_layer,
      }
      for (const icon in info_marker) {
        if(info_marker[icon].length > 0){
          let layer = L.layerGroup(info_marker[icon])
          overlayMaps[icon.toProperCase()] = layer
        }
      }
      this.layerControl = L.control.layers(baseMaps, overlayMaps).addTo(this.map)
      if(this.category.kml_url){
        for (const kml of this.category.kml_url) {
          if(kml.url && kml.exposure != 'organizer_only'){
            let kmz = L.kmzLayer()
            kmz.on('load', function(e) {
              e.layer.eachLayer(function(layer){
                if (layer instanceof L.Marker){
                  let pos = layer.getLatLng()
                  let popup = layer.getPopup()
                  let old_text,new_text
                  if(popup){
                    old_text = layer.getPopup().getContent()
                    new_text = old_text + '<br><br><a target="_blank" href="https://www.google.com/maps/search/?api=1&query='+pos.lat+'%2C'+pos.lng+'">'+that.$trans('raceplan.event_category.travel_to')+'</a>'
                    layer.setPopupContent(new_text)
                  }else{
                    old_text = '<strong>'+kml.name+'</strong>'
                    new_text = old_text + '<br><br><a target="_blank" href="https://www.google.com/maps/search/?api=1&query='+pos.lat+'%2C'+pos.lng+'">'+that.$trans('raceplan.event_category.travel_to')+'</a>'
                    layer.bindPopup(new_text)
                  }
                }
              })
              that.layerControl.addOverlay(e.layer, kml.name)
            })
            // Add remote KMZ files as layers (NB if they are 3rd-party servers, they MUST have CORS enabled)
            kmz.load(kml.url)
          }
        }
      }

      let runner_icons = {
        'first': {'icon': "/asset/image/runner-leader-male.svg", 'marker_fillcolor': '#fcfc03', 'text': 'Est. 1st.', 'background': 'rgba(255,67,67,0)', 'color': '#000'},
        'last': {'icon': "/asset/image/runner-last-all.svg", 'marker_fillcolor': '#ff8911', 'text': 'COT', 'background': 'rgba(255,67,67,0)', 'color': '#000'},
      }
      let pacers = this.category.pacer_title ?? []
      for (let i = 0; i < pacers.length; i++) {
        if(pacers[i]){
          runner_icons[pacers[i]] = {'icon': "/asset/image/runner-pacer.svg", 'marker_fillcolor': '#80fffd', 'text': pacers[i], 'background': 'rgba(255,67,67,0)', 'color': '#000'}
        }
      }
      runner_icons['you'] = {'icon': "/asset/image/runner-middle.svg", 'marker_fillcolor': '#27e780', 'text': 'You', 'background': 'rgba(255,67,67,255)', 'color': '#fff'}
      let runnerIcons = {}
      for (const runner_type in runner_icons) {
        let options = {
          iconUrl: runner_icons[runner_type].icon,
          shadowUrl: '',
          iconSize:     [30, 30], // size of the icon
          iconAnchor:   [15, 30], // point of the icon which will correspond to marker's location
          popupAnchor:  [0, -25] // point from which the popup should open relative to the iconAnchor
        }
        runnerIcons[runner_type] =  L.icon(options)
        let marker = L.marker([0, 0], {icon : runnerIcons[runner_type]}).addTo(this.map)
        marker.bindPopup(runner_icons[runner_type].text)
        this.runner_markers[runner_type] = marker
      }
    },

    async downloadFileFromUrl(url){
      let filename = url.split('/')
      filename = filename[filename.length-1]
      fetch(url, {
            method: 'GET', // or 'GET' if appropriate for your case
          })
          .then(response => response.blob()) // Convert the response to a Blob
          .then(blob => {
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl); // Clean up the created URL
          });
    },

    async generateGIF(){
      let that = this
      let chartElement = document.getElementById('chart_area')
      let width = chartElement.offsetWidth;
      let height = chartElement.offsetHeight;
      let gif = null
      let count = 0
      let scale = 0.55
      for (let i = 0; i < this.predict_times_key.length; i++) {
        count++
        if(count !== 1 && count !== this.predict_times_key.length && count%2 === 0){
          continue
        }
        let delay = 350
        if(count === 1 || count === this.predict_times_key.length){
          delay = 1500
        }
        let percent = Math.floor((count / this.predict_times_key.length)*100)
        this.download_progress = "("+percent+"%)"
        this.time_slider = i
        this.changeTimeRange()
        const filter = (node) => {
          const exclusionClasses = ['remove-me', 'secret-div'];
          if(node.tagName === 'image' && node.href){
            return false
          }
          return !exclusionClasses.some((classname) => node.classList?.contains(classname));
        }
        let canvas
        if(this.user_agent && (this.user_agent.browser.name == 'Safari' || this.user_agent.browser.name == 'Mobile Safari' || this.user_agent.os.name == 'iOS')) {
          canvas = await htmlToImage.toCanvas(chartElement, {
            cacheBust:true,
            skipFonts:true,
            filter:filter,
          })
        }else{
          canvas = await htmlToImage.toCanvas(chartElement, {
            cacheBust:true,
            skipFonts:true,
          })
        }
        if(gif === null){
          gif = new GIF({
            workers: 2,
            workerScript: '/asset/js/gif.worker.js',
            quality: 10,
            repeat: 0,
            // width: canvas.width*scale,
            // height: canvas.height*scale,
          })
        }
        // let new_canvas = document.createElement('canvas')
        // let new_ctx= new_canvas.getContext("2d")
        // let cw = canvas.width
        // let ch = canvas.height
        // new_canvas.width=cw
        // new_canvas.height=ch
        // new_ctx.drawImage(canvas,0,0,cw,ch,0,0,cw*scale,ch*scale)
        gif.addFrame(canvas, {delay: delay})
      }
      that.download_progress = '(Compressing Image...)'
      gif.on('finished', function(blob) {
        that.download_progress = ''
        let url = window.URL.createObjectURL(blob)
        let filename = that.event.slug+"_plan.gif"
        let element = document.createElement('a')
        element.setAttribute('href', url)
        element.setAttribute('download', filename)
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(element)

      })
      gif.render()

    },

    findRange(selected_distance, annotations){
      let start = 0
      let end = annotations[0].x
      let annotation, index
      for(index=0; index<annotations.length; index++){
        if(selected_distance > annotations[index].x){
          start = annotations[index].x
          annotation = annotations[index]
        }else{
          end = annotations[index].x
          annotation = annotations[index]
          break
        }
      }
      let result = {range: [start, end], annotation: annotation, index: index}
      return result
    },

    changeTimeRange(row_clicked = true){
      if(!(this.total_hour || this.total_minute > 0)){
        return
      }
      if(!this.chart_elevation_options || !this.chart_elevation_options.annotations){
        return
      }
      if(!this.chart_elevation_options_original || !this.chart_elevation_options_original.annotations){
        this.chart_elevation_options_original = JSON.parse(JSON.stringify(this.chart_elevation_options))
      }
      let locale = {
        'en': 'en-US',
        'th': 'th-TH',
      }
      let time = this.predict_times_key[this.time_slider]
      let t = this.category.start_date.split(/[- :]/)
      let world_time = new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5])
      world_time.setSeconds(world_time.getSeconds() + time)
      let options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' }

      let label = ''
      label += "<div style='font-size: 12px;'>"+ this.$trans('raceplan.event_category.plan_time')+"</div>"
      label += this.seconds2time(time)
      this.time_slider_label = label
      let local_time = world_time.toLocaleTimeString("th-TH", {hour12: false})
      this.world_time_slider_label =  "<div style='font-size: 12px'>"+ this.$trans('raceplan.event_category.local_time') +"</div>" + local_time
      this.world_date_slider_label = "<div style='font-size: 12px; color: #f3c800;'>"+world_time.toLocaleDateString(locale[this.$locale()], options)+"</div>"
      let annotations = JSON.parse(JSON.stringify(this.chart_elevation_options_original)).annotations

      let runner_icons = {
        'first': {'icon': "/asset/image/runner-leader-male.svg", 'marker_fillcolor': '#fcfc03', 'text': 'Est. 1st.', 'background': 'rgba(255,67,67,0)', 'color': '#000'},
        'last': {'icon': "/asset/image/runner-last-all.svg", 'marker_fillcolor': '#ff8911', 'text': 'COT', 'background': 'rgba(255,67,67,0)', 'color': '#000'},
      }
      let pacers = this.category.pacer_title ?? []
      for (let i = 0; i < pacers.length; i++) {
        if(pacers[i]){
          runner_icons[pacers[i]] = {'icon': "/asset/image/runner-pacer.svg", 'marker_fillcolor': '#80fffd', 'text': pacers[i], 'background': 'rgba(255,67,67,0)', 'color': '#000'}
        }
      }
      runner_icons['you'] = {'icon': "/asset/image/runner-middle.svg", 'marker_fillcolor': '#27e780', 'text': 'You', 'background': 'rgba(255,67,67,255)', 'color': '#fff'}
      for (const runnerKey in runner_icons) {
        let predict_distance = this.predict_times[runnerKey][time] * 1000
        let point = this.findPointByDistance(predict_distance)
        if(point){
          let marker = this.runner_markers[runnerKey]
          marker.setLatLng([point.lat, point.lon])
          let text = runner_icons[runnerKey].text + '<br><br><a target="_blank" href="https://www.google.com/maps/search/?api=1&query='+point.lat+'%2C'+point.lon+'">'+this.$trans('raceplan.event_category.travel_to')+'</a>'
          marker.setPopupContent(text)
          let leader_range = this.findRange(predict_distance, this.annotations)
          if(row_clicked && leader_range && (!this.chart_selected_result || this.chart_selected_result.index != leader_range.index)){
            this.rowClicked(Math.max(1, leader_range.index), 'select')
          }
          let runner_point = {
            id: 'runner',
            x: predict_distance,
            y: point.ele,
            fillColor: '#B3F7CA',
            "label": {
              "borderColor": '#ff4343',
              "style": {
                "color": runner_icons[runnerKey].color,
                "background": runner_icons[runnerKey].background,
              },
              "offsetY" : -10,
              "text": runner_icons[runnerKey].text,
            },
          }
          if(this.user_agent && (this.user_agent.browser.name == 'Safari' || this.user_agent.browser.name == 'Mobile Safari' || this.user_agent.os.name == 'iOS')){
            runner_point.marker = {
              "size": 8,
              "fillColor": runner_icons[runnerKey].marker_fillcolor,
              "strokeWidth": 1,
            }
          }else{
            runner_point.marker = {"size": 0}
            runner_point.image = {
              "path" : runner_icons[runnerKey].icon,
              "width" : 25,
              "height" : 25,
              "offsetX" : 0,
              "offsetY" : 0
            }
          }
          annotations.points.push(runner_point)
        }
      }

      let time_for_color = local_time.substring(0, 5)
      let colors = this.elevation_chart_color_lookup(time_for_color)
      let grid = this.chart_elevation_options.grid
      let fill = this.chart_elevation_options.fill
      grid.row.colors = [colors.sky, colors.sky]
      fill.gradient.gradientToColors = [colors.mountain]
      this.chart_elevation_options = {
        ...this.chart_elevation_options,
        ...{
          annotations: annotations,
          grid: grid,
          fill: fill,
        },
      }
    },

    elevation_chart_color_lookup(time){
      let time_colors = {
        "00:00": {sky: "#5A507D", mountain: "#6ea048"},
        "01:00": {sky: "#5A507D", mountain: "#6ea048"},
        "02:00": {sky: "#5A507D", mountain: "#6ea048"},
        "03:00": {sky: "#5A507D", mountain: "#6ea048"},
        "04:00": {sky: "#6D6781", mountain: "#6ea048"},
        "04:30": {sky: "#D09195", mountain: "#6ea048"},
        "05:00": {sky: "#F0B6A4", mountain: "#91c366"},
        "06:00": {sky: "#F0B6A4", mountain: "#91c366"},
        "07:00": {sky: "#86EAC4", mountain: "#bce392"},
        "08:00": {sky: "#87E9E7", mountain: "#bce392"},
        "09:00": {sky: "#88DDE8", mountain: "#bce392"},
        "10:00": {sky: "#88DDE8", mountain: "#bce392"},
        "11:00": {sky: "#88DDE8", mountain: "#bce392"},
        "12:00": {sky: "#88DDE8", mountain: "#bce392"},
        "13:00": {sky: "#88DDE8", mountain: "#bce392"},
        "14:00": {sky: "#88DDE8", mountain: "#bce392"},
        "15:00": {sky: "#88DDE8", mountain: "#bce392"},
        "16:00": {sky: "#88DDE8", mountain: "#bce392"},
        "16:30": {sky: "#86EAC4", mountain: "#bce392"},
        "17:00": {sky: "#F0B6A4", mountain: "#91c366"},
        "18:00": {sky: "#F0B6A4", mountain: "#91c366"},
        "19:00": {sky: "#D09195", mountain: "#6ea048"},
        "20:00": {sky: "#6D6781", mountain: "#6ea048"},
        "21:00": {sky: "#5A507D", mountain: "#6ea048"},
        "22:00": {sky: "#5A507D", mountain: "#6ea048"},
        "23:00": {sky: "#5A507D", mountain: "#6ea048"},
      }
      let keys = Object.keys(time_colors)
      keys.sort()
      let found = ""
      for (const key of keys) {
        if(key > time){
          break
        }
        found = key
      }
      return time_colors[found]
    },
  },
}

Date.prototype.addSeconds = function(s) {
  this.setTime(this.getTime() + (s*1000))
  return this
}

Date.prototype.toMySQLFormat = function() {
  return new Date(this.getTime() - (this.getTimezoneOffset() * 60000 ))
      .toISOString().replace('T', ' ').split('.')[0]
}

String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};
</script>

<style scoped>
.no-gutter {margin-right: 0;margin-left: 0;}
.no-gutter > [class*="col-"] {padding-right: 0;padding-left: 0;}
.chart{margin-bottom: 1em;}
table.template{width: 100%;}
.container{
  padding-left: 0px!important;
  padding-right: 0px!important;
}
#event-header-box{
  width: 80%;
  padding: 1em;
  background-color: #dce1f3;
}
#event-header{font-size: 24px;font-weight: bolder;}
#event-sub-header{font-size: 16px;}
#event-date{
  margin-top: 2em;
  font-size: 16px;
  color: #00cc66;
}
.link-box{padding: 1em;text-align: center;background-color: aliceblue;}
.bg-dark-blue{color: #ffffff;background-color: #1e294f;}
#countdown-box{padding: 1em;}
#countdown{font-size: 24px;font-weight: bolder;}

.table-input td, .table-input th, .table-plan th, .table-plan td{text-align: center;}
.table-input input{width: 3em;border: none;border-bottom: 2px solid rgba(221, 221, 221, 1);}
.table-input{ border-top: 1px solid rgba(245, 245, 245, 1); border-bottom: 1px solid rgba(245, 245, 245, 1);}
.table-input th{padding-top: 0.5em;}
.table-input td, .table-plan td{padding-bottom: 0.5em;}
.table-input th, .table-input td{ border-left: 1px solid rgba(245, 245, 245, 1); }
.table-input th:first-child, .table-input td:first-child{ border-left: none; }

.table-plan{ border-top: 1px solid rgba(245, 245, 245, 1); border-bottom: 1px solid rgba(245, 245, 245, 1);vertical-align: middle;}
.table-plan th, .table-plan td{padding-top: 0.2em;padding-bottom: 0.2em;}
.table-plan th, .table-plan td{ border-left: 1px solid rgba(245, 245, 245, 1); }
.table-plan thead{}
.table-plan .section-info{background-color: #d8ead2; vertical-align: middle;}
.table-plan .section-plan{background-color: #85D5FFFF;vertical-align: middle;}
.table-plan .section-nutrition-required{background-color: #f6c6a9;vertical-align: middle;}
.table-plan .section-nutrition-plan{background-color: #b5817b;vertical-align: middle;}
.fit-content{width: 1%; white-space: nowrap;}
tr.selected{background-color: #e0fbe9}
.selected .col-input{min-width: 8em;}
.table-plan th{ border-bottom: 1px solid rgba(245, 245, 245, 1); border-top: 1px solid rgba(245, 245, 245, 1);}
.table-plan th:first-child, .table-plan td:first-child{ border-left: none; }
.bg-red{background-color: #ff9391}
.input-time{width: 3em}
.table-nutrition{vertical-align: middle}
.table-nutrition thead tr td:nth-child(3){border-right: 1px black solid;}
.table-nutrition tbody tr td:nth-child(4){border-right: 1px black solid;}
.input_menu_nutrients{width: 5em;margin-left: auto;margin-right: auto;}
.height-alert-1{color: #ffc302;}
.height-alert-2{color: #ff8f00;}
.height-alert-3{color: #ff5b00;}
.height-alert-4{color: #ff0505;}
.div-anno-subset{padding-top: 0.1em;padding-bottom: 0.1em;}
@media print {
  .print-chart {
    width: 500px;
  }
}
#time_slider::before {
  content: '\25c4';
  padding-right: 0.5em;
}
#time_slider::after {
  content: '\25ba';
  padding-left: 0.5em;
}
/* -------------------------------------------------------------------------
VERTICAL STEPPERS
-------------------------------------------------------------------------- */

/* Steps */
.step {
  position: relative;
  min-height: 1em;
  color: black;
  margin: 1em;
}
.step + .step {
  margin-top: 1.5em
}
.step > div:first-child {
  position: static;
  height: 0;
}
.step > div:not(:first-child) {
  margin-left: 1.5em;
  padding-left: 1em;
}
.step.step-active, .step:hover{
  font-size: 1.3em;
  transform-origin: top left;
  color: #4285f4;
  cursor: pointer;
}

/* Circle */
.step .circle {
  background: gray;
  position: relative;
  width: 1.5em;
  height: 1.5em;
  line-height: 1.5em;
  border-radius: 100%;
  color: #fff;
  text-align: center;
  box-shadow: 0 0 0 3px #fff;
}

/* Stepper Titles */
.step .title {
  line-height: 1.5em;
  font-weight: bold;
  cursor: pointer;
}
.step .caption {
  font-size: 0.8em;
}
.time_label{
  border: 3px solid #249ed9;
  color: #249ed9;
  border-radius: 25px;
  padding-top: 5px;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 1.5em;
  font-weight: bolder;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.chart_area_logo{
  max-height: 135px;
  max-width: 100%;
}
#chart_area{
  background-color: #fff;padding-top: 15px;
  min-width: 1000px;
  margin-bottom: 0;
}
.td-chart{
  max-width: 0;
}
.chart_area_parent{
  overflow-x: auto;
  overflow-y: hidden;
}
.not-available{
  opacity: 0.5;
  -webkit-filter: grayscale(1); /* Old WebKit */
  filter: grayscale(1);
}
.bg-g{
  background-repeat: no-repeat;
  /*background-attachment: fixed;*/
  background-position: center;
  background-size: cover;
  width: 100%;
}
.bg-1 {
  background-image: url(https://runningconnect-media-jp.s3.ap-northeast-1.amazonaws.com/TimingConnect/game/g1-bg.jpg);
}
.bg-2 {
  background-image: url(https://runningconnect-media-jp.s3.ap-northeast-1.amazonaws.com/TimingConnect/game/g2-bg.jpg);
}
.bg-3 {
  background-image: url(https://runningconnect-media-jp.s3.ap-northeast-1.amazonaws.com/TimingConnect/game/g3-bg-c.jpg);
}
</style>
<style>
.leaflet-control-attribution{
  font-size: 7px;
}
</style>
